//  import {
//    /*  BootstrapTable, */
//     /* paginationFactory, *//* Button, ButtonToolbar, Card, ReactDOM,
//     Form, Col, Row, axios, Container, */ /* Banner, *//*  Typeahead, TimePicker, */
//     /* cellEditFactory, */ Type, /* moment, *//*  NavLink, Alert, */ /* AppConfiguration, */
//     NoserLoading, Noser, sizePerPageRenderer,/*  DatePicker, */ /* Tabs, Tab, */ /* Accordion,Navigate */
// } 
// from '../../../noser-hris-components';

import {
    // Col,
    // Container,
    // Row,
    // Dropdown,
    // DropdownToggle,
    // DropdownMenu,
    // DropdownItem,
    Input,
    // Modal,
    // ModalBody,
    // Form,
    // FormGroup,
    // Label,
    // Spinner,
    // Alert,
    /* Button */
    Spinner,
  } from "reactstrap";
import React, { Component } from 'react';
//import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
//import paginationFactory from 'react-bootstrap-table2-paginator';
import { Button, ButtonToolbar, Card,  Tabs, Tab,   DropdownButton, Accordion,Form,Col,Row,/* Alert, */Container } from "react-bootstrap";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Typeahead } from 'react-bootstrap-typeahead';
import "react-bootstrap-typeahead/css/Typeahead.css";
import axios from 'axios';
import moment from 'moment';
import { AppConfiguration } from "read-appsettings-json";
import { Navigate } from "react-router-dom";
//import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
//import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { NumericFormat } from 'react-number-format';
import { PatternFormat } from 'react-number-format';
import { Alert } from 'reactstrap';
import Resizer from "react-image-file-resizer";
import '../../../wcomponents/w.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import AWS from "aws-sdk";


import { Label, Modal } from 'reactstrap';



class ApplicationFormEdit extends Component {
    globalNewId = "";
    constructor(props) {
        super(props)

        const now = new Date();
        this.state = {
            loading : false,
            matchedDocumentUrl: '',
            matchedDocumentName: '',
            documentShow: false,
            newId: "",
            
            s3NewId: `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`,

            startDate: new Date(),
            // selected: [],
            userinfo  :   [],
            isloading :   false,
            isshow    :   false,
            alerttype :   "",
            message   :   "",
            color     :   "",
            fade      :   true, 
            
            disableRemoveEducation:true,

            clientDDL       : [],
            clientId        : "",
            clientName      : "",
            positionDDL     : [],
            positionId      : "",
            positionName    : "",
            dateApplied     : "",
            titleDDL: [
                {name: 'Select Name Title', value: "",},
                {name: 'MR.',               value: 'Mr.',},
                {name: 'MS.',               value: 'Ms.',},
                {name: 'MRS.',              value: 'Mrs.',},
            ],
            suffixDDL: [
                {name: 'Select Suffix Name', value: "",},
                {name: 'SR',               value: 'SR',},
                {name: 'JR',               value: 'JR',},
                {name: 'I',              value: 'I',},
                {name: 'II',              value: 'II',},
                {name: 'III',              value: 'III',},
                {name: 'IV',              value: 'IV',},
                {name: 'V',              value: 'V',},
                {name: 'VI',              value: 'VI',},
                {name: 'VII',              value: 'VII',},
                {name: 'VIII',              value: 'VIII',},
                {name: 'IX',              value: 'IX',},
                {name: 'X',              value: 'X',},
            ],
            titleValue  : "",
            fName       : "",
            nName       : "",
            mName       : "",
            lName       : "",
            sName       : "",
            typeDDL: [
                {name: 'Select Address Type',   value: "",},
                {name: 'CURRENT ADDRESS',       value: '0',},
                {name: 'REGISTERED ADDRESS',    value: '1',},
                {name: 'PROVINCIAL ADDRESS',    value: "2",},
                {name: 'CORRESPONDENCE ADDRESS',value: '3',},
                {name: 'FOREIGN ADDRESS',       value: '4',},
            ],
            typeId      : "",
            regionDDL   : [],
            region      : "",
            regionId    : "",
            regionName  : "",
            provinceonloadDDL : [],
            provinceDDL : [],
            provinceId  : "",
            provinceName: "",
            cityDDL     : [],
            cityId      : "",
            cityName    : "",
            houseNumber : "",
            street      : "",
            barangay    : "",
            postalCode  : "",
            hpNumber    : "",
            opNumber    : "",
            mobileNumber: "",
            emailAddress: "",
            facebook    : "",
            twitter     : "",
            nationalityDDL: [
                {name: 'Select Citizenship',value: "",},
                {name: 'FILIPINO',          value: '1',},
                {name: 'OTHERS',            value: '2',},
            ],
            nationalityId : "",
            religionDDL: [
            ],
            religionId : "",
            genderDDL: [
                {name: 'Select Gender', value: "",},
                {name: 'MALE',          value: 'MALE',},
                {name: 'FEMALE',        value: 'FEMALE',},
            ],
            genderValue : "",
            civilStatusDDL: [
                {name: 'Select Civil Status', value: "",},
                {name:"SINGLE",         value:"SINGLE"},
                {name:"MARRIED",        value:"MARRIED"},
                {name:"DIVORCED",       value:"DIVORCED"},
                {name:"SEPARATED",      value:"SEPARATED"}
            ],
            civilStatusValue : "",
            ageYear  :   "",//,new Date().getFullYear(),
            ageMonth :   "",//,new Date().getMonth()+1,
            dateOfBirth : "",
            fromStart : "",
            toEnd: "",
            totalAge : "",
            placeOfBirth : "",
            height : "",
            weight : "",
            sSkills : "",
            lSpoken : "",
            ecName : "",
            relationship : "",
            ecNumber : "",
            sss : "",
            tin : "",
            phic : "",
            pagibig : "",


            levelDDL  :    [
                {"name": 'Select Level', "value": "",},
                {"name":"COLLEGE","value":"0"},
                {"name":"HIGH SCHOOL","value":"1"},
                {"name":"SENIOR HIGH SCHOOL","value":"5"},
                {"name":"JUNIOR HIGH SCHOOL","value":"4"},
                {"name":"ELEMENTARY","value":"2"},
                {"name":"OTHERS","value":"3"},
            ],
            levelDDLtwo  :    [
                {"id":"1","name":"COLLEGE","LevelId":"0", "isModified":"0","isDeleted":"0"},
                {"id":"2","name":"HIGH SCHOOL","LevelId":"1", "isModified":"0","isDeleted":"0"},
                {"id":"3","name":"SENIOR HIGH SCHOOL","LevelId":"5", "isModified":"0","isDeleted":"0"},
                {"id":"4","name":"JUNIOR HIGH SCHOOL","LevelId":"4", "isModified":"0","isDeleted":"0"},
                {"id":"5","name":"ELEMENTARY","LevelId":"2", "isModified":"0","isDeleted":"0"},
                //{"id":"6","name":"OTHERS","LevelId":"3", "isModified":"0","isDeleted":"0"},
            ],
            LevelId : "",
            tblLevelArrLst  :   [],
            SchoolName:"",
            Course:"",
            StartYear:"",
            EndYear:"",
            honorsAward:"",
            educationGrid : [],

            checkIsFreshGraduate : false,
            isEmploymentDisabled : false,
            erCompanyName : "",
            erCompanyAddress : "",
            erPosition : "",
            erPeriodCover : "",
            erSalary : "",
            erSupervisor : "",
            erCNumber : "",
            erRFLeaving : "",
            erTCIncome : "",
            erWHTax : "",
            erYOCompensation : "",
            erMPAOB : "",
            erDBenefits : "",
            erMDeduction : "",
            erNTSOFOC: "",
            erBasicSalary : "",
            erTMPOB : "",
            erTSPFOC : "",
            erBPFMWE : "",
            erHPFHWE : "",
            erOPFHWE : "",
            erNDPFHWE : "",
            erRemarks : "",
            employmentRecordGrid : [],
            disableRemoveEmploymentRecord : true,

            roleDDL  :    [
                {"name": 'Select Role', "value": "",},
                {"name":"FATHER",       "value":"0"},
                {"name":"MOTHER",       "value":"1"},
                {"name":"SPOUSE",       "value":"2"},
                {"name":"BROTHER",      "value":"3"},
                {"name":"SISTER",       "value":"4"},
                {"name":"CHILD",        "value":"5"},
            ],
            roleDDLtwo  :    [
                
                {"id":"1","name":"FATHER",       "RoleId":"0"},
                {"id":"2","name":"MOTHER",       "RoleId":"1"},
                {"id":"3","name":"SPOUSE",       "RoleId":"2"},
                {"id":"4","name":"BROTHER",      "RoleId":"3"},
                {"id":"5","name":"SISTER",       "RoleId":"4"},
                {"id":"6","name":"CHILD",        "RoleId":"5"},
            ],
            tblRoleArrLst : [],
            RoleId : "",
            fbName : "",
            fbAge : "",
            fbOccupation : "",
            fbCOSchool : "",
            fbCNumber : "",
            disableBackground : true,
            familyBackgroundGrid : [],

            tblJobOpeningArrLst : [],
            jobOpeningDDL  :    [
                // {"name": 'Select Job Opening',  "value": "",},
                // {"name":"BESTJOBS",             "value":"1"},
                // {"name":"CLASSIFIED ADS",       "value":"2"},
                // {"name":"FIELD COLLECTORS",     "value":"3"},
                // {"name":"JOBSTREET",            "value":"4"},
                // {"name":"OTHERS",               "value":"5"},
                // {"name":"PESO",                 "value":"6"},
                // {"name":"REFERRAL",             "value":"7"},
            ],
            jobSourceId : "",
            jobSource : "",
            oReferredBy : "",
            checkORelativeYes : false,
            checkORelativeNo : true,
            disabledRelative : false,
            oRelativeName : "",
            oCNumber : "",
            oRelationship : "",
            oJobTitle : "",
            disableOthers : true,

            checkConvictedYes : false,
            checkConvictedNo : true,
            oCrime : "",
            disabledConvicted : false,

            checkLaborUnionYes : false,
            checkLaborUnionNo : true,
            disabledLaborUnion : true,
            luDetails : "",
            checkChronicDiseaseYes : false,
            checkChronicDiseaseNo : true,
            disabledDisease : true,

            tblDiseaseArrLst : [],
            diseaseDDL  :    [
                {"name": 'Select Chronic Disease',  "value": "",},
                {"name":"ALLERGIES",            "value":"1"},
                {"name":"ASTHMA",               "value":"2"},
                {"name":"DIABETES",             "value":"3"},
                {"name":"HEPA B",               "value":"4"},
                {"name":"HYPERTENSION",         "value":"5"},
                {"name":"N/A",                  "value":"6"},
                {"name":"OTHERS",               "value":"7"}
            ],
            diagnoseDeseaseId : "",
            othersGrid : [],

            referralDDL:[],
            referralLst:[],
            disablereferral: true,
            referralId:"",
            referenceName : "",
            referenceOccupation : "",
            referenceCOSchool : "",
            referenceCNumber : "",
            referenceGrid : [],
            disableReference : true,

            checkDisclaimer : false,
            disablebutton : true,

            arrangementId       :   "",
            arrangement         :   "",
            bloodtypeId         :   "",
            bloodtype           :   "",

            arrangementDDL      :   [],
            bloodtypeDDL        :   [],

            firstNamekeycode    :   "",
            middleNamekeycode   :   "",
            lastNamekeycode     :   "",
            nickNamekeycode     :   "",
            newImage: "",
            file : "",
            newImageShow: false,
            photoLabel : true,
            uploadResume : "",

            //w value af
            clientIdAH : "",
            clientNameAH: "",
            positionIdAH: "",
            positionNameAH:"",
            refNoAF : "",
            dateAppliedAF: "",
            remarksAF : "",
            applicationHistoryGrid: [],
            typeofcharacterreference:[
                {"name": 'Select Role', "value": ""},
                {"name":"Previous Employment", "value" : "0"},
                {"name":"Neighbor", "value" : "1"}
            ],
            tbltypeofcharacterreferenceArrLst : [],
            typeofcharacterreferenceId : "",
            typeofcharacterreferenceName : "",
            wstartDate : "",
            wendDate: "",
            //others
            referealOthersTA: true,
            referealOthersTXT : false,
            fileImage : "",
            candiProfile: [],


            titleValue : "",
            headerId : "",
            UserId : "",
            CandidateProfileId  : "",

            fileInputVisible: true,
        }
        this.fileChangedHandler = this.fileChangedHandler.bind(this);
        this.fileUploadChangedHandler = this.fileUploadChangedHandler.bind(this);
         this.fileInputRef = React.createRef();
    }

    getFormattedDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
    
        return `${year}${month}${day}${hours}${minutes}${seconds}`;
    };


    componentDidMount() {

        this.globalNewId = this.getFormattedDateTime();
        //console.log("Global New ID on first run:", this.globalNewId);

        // const sleep = (milliseconds) => {return new Promise(resolve => setTimeout(resolve, milliseconds))}
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userCollection"))
        // this.GetClient(); 
        // this.GetPosition();
        
        this.Gettypeofcharacterreference();

        this.GetClient(); 
        this.GetPosition();
        this.GetRegion();
        this.GetProvince();
        this.GetCity();
        this.GetLevel();
       // this.Gettypeofcharacterreference();

        this.GetRole();
        this.GetDisease();
        this.GetJobOpening();
        this.GetLivingArrangements()
        // if(this.state.checkORelativeNo === true) {
        //     this.setState({
        //         disabledRelative : true,
        //         oRelativeName : "",
        //         oCNumber : "",
        //         oRelationship : "",
        //         oJobTitle : "",
        //     })
        // }
        // if(this.state.checkConvictedNo === true) {
        //     this.setState({
        //         disabledConvicted : true,
        //         oCrime : "",
        //     })
        // }
        // if(this.state.checkLaborUnionNo === true) {
        //     this.setState({
        //         disabledLaborUnion : true,
        //         luDetails : "",
        //     })
        // }
        // if(this.state.checkChronicDiseaseNo === true) {
        //     this.setState({
        //         disabledDisease : true,
        //         diagnoseDeseaseId : "",
        //     })
        // }
        this.getCandiProfile()
         //this.autofillEducation()
        //this.GetLivingArrangements()
        
        /* this.state.referenceGrid = [
            {
                "id": moment(new Date()).format('HHMMSS') + 1,
                "typeId" : "",
                "typeofCharacterReferenceName" : "",
                "name"          :   "",
                "contactNumber" :   "",
                "occupation"    :   "",
                "company"       :   "",
                "userId"        :   this.state.userinfo.userid,
                "isDeleted"    :    "0",  
            },
            {
                "id": moment(new Date()).format('HHMMSS') + 2,
                "typeId" : "",
                "typeofCharacterReferenceName" : "",
                "name"          :   "",
                "contactNumber" :   "",
                "occupation"    :   "",
                "company"       :   "",
                "userId"        :   this.state.userinfo.userid,
                "isDeleted"    :    "0",  
            },
            {
                "id": moment(new Date()).format('HHMMSS') + 3,
                "typeId" : "",
                "typeofCharacterReferenceName" : "",
                "name"          :   "",
                "contactNumber" :   "",
                "occupation"    :   "",
                "company"       :   "",
                "userId"        :   this.state.userinfo.userid,
                "isDeleted"    :    "0",  
            }
        ] */
    };
    ValidNumeric(val){
        var regex = /^\d+(.\d+)?$/;
        return !regex.test(val)
    };
    IsNumeric(evt){
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode( key );
        var regex = /^\d+(.\d+)?$/;
        if( !regex.test(key) ) {
        theEvent.returnValue = false;
        if(theEvent.preventDefault) theEvent.preventDefault();
        }
        
    };
    IsDecimal(evt){
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode( key );
        var regex = /^\d*\.?(?:\d{1,2})?$/;
        if( !regex.test(key) ) {
        theEvent.returnValue = false;
        if(theEvent.preventDefault) theEvent.preventDefault();
        }
    };

    getCandiProfile=()=>{
   
        //console.log("getCandiProfile")
        let filter_data = {
          /* "isDeleted" : "0",  */
          "UserId" : this.state.userinfo[0].userid,
          //"isDeleted" : "0",
         /*  "firstName" : firstName,
          "lastName"  : lastName, */
        }
        
        const Params = {
          "_collection" : "CandidatesProfile",
          "filter_data" : filter_data
        }
        //console.log("Params")
        //console.log(Params)
        //console.log("s")
         axios
         .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {
  
            //console.log("res.data")
            //console.log(res)
    
            let dataTmp = []
            let a
            let dataaa = res.data
            //console.log("data")
            //console.log(dataaa)
            let newstr2=""
            dataaa.CandidatesProfile.map(function(itm,i){
              let strJson = "{" + itm.substring(46, itm.length)
              let strJson2 = itm.substring(18, itm.length)
              newstr2 = strJson2.split("')")[0]
              let json = JSON.parse(strJson.replace(/'/g,'"'));
              json.headerId = newstr2
              //console.log(json.headerId)
              //setheaderId(json.headerId)
              dataTmp.push(json)
              //console.log(json)
              a = json
              //console.log(a.AgeYear)
            })    
           
            //console.log("dataTmp")
            //console.log(a.AgeYear)
            //this.setState({candiProfile : dataTmp })
            var today = new Date();
            var birthDate = new Date(a.DateOfBirth);
            var age_now = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
            {
                age_now--;
            }
            this.setState({
                
                fName               : a.FirstName,
                nName               : a.NickName,
                mName               : a.MiddleName,
                lName               : a.LastName,
                sName               : a.SuffixName,
                titleValue          : a.Title,
                hpNumber            : a.HomePhoneNumber,
                totalAge            : age_now,
                ageMonth            : new Date(a.DateOfBirth).getMonth()+1,
                ageYear             : birthDate.getFullYear(),
                dateApplied         : a.DateApplied,//new Date(a.DateApplied),
                dateOfBirth         : new Date(a.DateOfBirth),
                opNumber            : a.OfficeNumber,
                mobileNumber        : a.MobileNumber,
                emailAddress        : a.EmailAddress,
                facebook            : a.Facebook,
                twitter             : a.Twitter,
                nationalityId       : a.NationalityId,
                religionId          : a.ReligionId,
                genderValue         : a.Gender,
                civilStatusValue    : a.CivilStatus,                
                placeOfBirth        : a.PlaceOfBirth,
                height              : a.Height,
                weight              : a.Weight,
                sSkills             : a.SpecialSkills,
                lSpoken             : a.LanguageSpoken,
                ecName              : a.EmergencyContactName,
                relationship        : a.EmergencyContactRelation,
                ecNumber            : a.EmergencyContactNumber,
                
                sss                 : a.SSSNumber,
                tin                 : a.TINNumber,
                phic                : a.PHICNumber,
                pagibig             : a.HDMFNumber,

                arrangementId       : a.LivingArrangementId,
                arrangement         : a.Arrangement,
                bloodtypeId         : a.BloodTypeId,
                bloodtype           : a.BloodType,
                //arrangementId       : a.LivingArrangementId,
                //typeId              : a.applicantAddresses.TypeId,
                educationGrid : a.educationAttainments,
                employmentRecordGrid : a.employmentHistories,
                familyBackgroundGrid : a.familyBackgrounds,
                othersGrid : a.others,
                referenceGrid :a.characterReferences,
                headerId : a.headerId,
                UserId : a.UserId,
                CandidateProfileId : a.CandidateProfileId,
            })
            //console.log(a.educationAttainments)
            
            if(a.applicantAddresses.length>0){
                this.state.addressApplicationFormId= a.applicantAddresses.length>0 ? a.applicantAddresses[0]["applicationFormId"] : ""
                this.state.addressId=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["id"] : ""
                this.state.typeId=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["TypeId"] : ""
                this.state.regionId=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["RegionId"]: ""
                this.state.region=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["Region"] : ""
                this.state.provinceId=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["ProvinceId"] : ""
                this.state.provinceName=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["Province"] : ""
                this.state.cityId=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["CityId"] : ""
                this.state.cityName=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["City"] : ""
                this.state.houseNumber=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["HouseNumber"] : ""
                this.state.street=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["StreetName"] : ""
                this.state.barangay=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["Barangay"] : ""
                this.state.postalCode=a.applicantAddresses.length>0 ? a.applicantAddresses[0]["PostalCode"] : ""
            }
            let tmpeducationAttainments = a.educationAttainments
            tmpeducationAttainments.forEach((itm,idx) => {
                itm.id= parseFloat(idx+1)
            })
            let tmp2educationAttainments = tmpeducationAttainments
            for(let x = 0; x < tmp2educationAttainments.length; x++){
                this.state.educationApplicationFormId      = tmp2educationAttainments[x].applicationFormId
                this.state.educationId      = tmp2educationAttainments[x].id
               
            };
            // START employmentHistories APPLICATIONID
            let TmpemploymentHistories = a.employmentHistories
            TmpemploymentHistories.forEach((itm,idx) => {
                itm.id= parseFloat(idx+1).toString()
            })
            let Tmp2employmentHistories = TmpemploymentHistories
            for(let x = 0; x < Tmp2employmentHistories.length; x++){
                this.state.employmentApplicationFormId      = a.employmentHistories[x].applicationFormId
                this.state.employmentId      = a.employmentHistories[x].id
            };
            // START familyBackgrounds APPLICATIONID
            let TmpfamilyBackgrounds = a.familyBackgrounds
            TmpfamilyBackgrounds.forEach((itm,idx) => {
                itm.id= parseFloat(idx+1).toString()
            })
            let Tmp2familyBackgrounds = TmpfamilyBackgrounds
            for(let x = 0; x < Tmp2familyBackgrounds.length; x++){
                this.state.familyApplicationFormId      = Tmp2familyBackgrounds[x].applicationFormId
                this.state.familyId      = Tmp2familyBackgrounds[x].id
            }
           
            a.others.forEach(itm=>{
                this.state.othersApplicationFormId = itm.applicationFormId
                this.state.othersId = itm.id
                this.state.jobSourceId = itm.jobSourceId
                this.state.oReferredBy = itm.refferedBy

                this.state.disablereferral = false
                this.state.referealOthersTA = itm.jobSourceId ==="10" ? true : false
                this.state.referealOthersTXT = itm.jobSourceId ==="10" ? false : true


                this.state.checkORelativeYes = itm.hasCompanyRelative ==="1" ? true : false
                this.state.checkORelativeNo = itm.hasCompanyRelative ==="1" ? false : true
                this.state.disabledRelative = itm.hasCompanyRelative ==="1" ? false : true
                this.state.oRelativeName = itm.relativeName
                this.state.oRelationship = itm.relativeRelation
                this.state.oJobTitle = itm.relativePosition
                this.state.oCNumber = itm.relativeContactNumber
                

                this.state.checkConvictedYes = itm.isCrimeConvicted ==="1" ? true : false
                this.state.checkConvictedNo = itm.isCrimeConvicted ==="1" ? false : true
                this.state.disabledConvicted = itm.isCrimeConvicted ==="1" ? false : true
                this.state.oCrime = itm.crimeDescription
                
                this.state.checkLaborUnionYes = itm.isLaborUnion ==="1" ? true : false
                this.state.checkLaborUnionNo = itm.isLaborUnion ==="1" ? false : true
                this.state.disabledLaborUnion = itm.isLaborUnion ==="1" ? false : true
                this.state.luDetails = itm.laborUnionDescription

                this.state.checkChronicDiseaseYes = itm.diagnoseDeseaseId !=="" ? true : false
                this.state.checkChronicDiseaseNo = itm.diagnoseDeseaseId !=="" ? false : true
                this.state.disabledDisease = itm.diagnoseDeseaseId !=="" ? false : true
                this.state.diagnoseDeseaseId = itm.diagnoseDeseaseId
            })

            // START characterReferences APPLICATIONID
            let tmpcharacterReferences = a.characterReferences
            tmpcharacterReferences.forEach((itm,idx) => {
                itm.id= parseFloat(idx+1)
            })
            let tmp2characterReferences = tmpcharacterReferences
            for(let x = 0; x < tmp2characterReferences.length; x++){
                this.setState({
                    characterApplicationFormId : tmp2characterReferences[x].applicationFormId,
                    characterId : tmp2characterReferences[x].id,
                })
                //this.state.characterApplicationFormId      = data.characterReferences[x].applicationFormId
                //this.state.characterId      = data.characterReferences[x].id
            }

            // ---- ADDED BY NEL
            this.fetchS3Objects(dataTmp);
            this.fetchDocumentFromS3(dataTmp);
            // ----

        })
        .catch(error =>{
            /* alert("error: asdasd " + error) */
        })
    };

    GetLivingArrangements = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   "0",
            "UserId"        :  "0"
        };
        await axios.post(AppConfiguration.Setting().hrisapi + "Maintenance/GetLivingArrangements",  params)
        .then(res => {
            const data = res.data;
            this.setState({arrangementDDL:data.livingArrangements});
        })
        this.GetBloodTypes()
    }
    GetBloodTypes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
           "ClientId"      :   "0",
            "UserId"        :  "0"
        };
        await axios.post(AppConfiguration.Setting().hrisapi + "Maintenance/GetBloodTypes",  params)
        .then(res => {
            const data = res.data;
            this.setState({bloodtypeDDL:data.bloodTypes});
        })
        this.GetReferralList()
    }
    GetReligions = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   "1",
            "UserId"        :   "1"
        };
        await axios.post(AppConfiguration.Setting().hrisapi + "Maintenance/GetReligions",  params)
        .then(res => {
            const data = res.data;
            ////console.log("religion")
            ////console.log(data)
            let religionDDL = []
            religionDDL.push({"value":"","name":"Select Religion"})
            data.religions.map(function(itm){
                religionDDL.push({"value":itm.id,"name":itm.name})
            })
            this.setState({religionDDL:religionDDL});
        })
       
    };

    GetClient = async()=> {
        this.setState({isloading:true})
        const clientParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userid,
        };
        await
        axios
        .post(AppConfiguration.Setting().hrisapi + "Client/GetClientList",  clientParams)
        .then(res => {
            const data = res.data;
            this.setState({
                clientDDL   :   data.clients,
                isloading   :   false
            });
        })
        .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
    }
    handleChangedArrangement = e => {
        this.state.alerttype="";this.state.isshow=false;this.state.color="";this.state.message="";this.state.fade=true;
        if(e.length===0){
            this.state.arrangementId= ''
            this.state.arrangement=''
            return
        }
        this.state.arrangementId=e[0].id
        this.state.arrangement=e[0].name
    }
    handleChangedBloodType = e => {
        this.state.alerttype="";this.state.isshow=false;this.state.color="";this.state.message="";this.state.fade=true;
        if(e.length===0){
            this.state.bloodtypeId= ''
            this.state.bloodtype=''
            return
        }
        this.state.bloodtypeId=e[0].id
        this.state.bloodtype=e[0].name
    };

    handleChangeClient = (e) => {
        if(e.length == 0) {
            this.state.clientId     =   ""
            this.state.clientName   =   ""
            return
        }
        this.state.clientId     =   e[0].id
        this.state.clientName   =   e[0].name
        this.setState({
            isshow:false,
        })
    }

    GetPosition = async()=> {
        this.setState({isloading:true})
        const positionParams = {
            "IpAddress"     : "0.0.0.0",
            "ClientId"      : this.state.userinfo.clientId,
            "UserId"        : this.state.userinfo.userid,
            "SectionId"     : "",
            "DepartmentId"  : "",
            "Name"          : ""
        };
        await
        axios.post(AppConfiguration.Setting().hrisapi + "Maintenance/GetPositions",  positionParams)
        .then(res => {
            const data = res.data;
            this.setState({
                positionDDL : data.positions,
                isloading   : false
            });
        })
        
    }
    
    handleChangePosition = (e) => {
        if(e.length == 0) {
            this.state.positionId     =   ""
            this.state.positionName   =   ""
            return
        }
        this.state.positionId     =   e[0].id
        this.state.positionName   =   e[0].name
        this.setState({
            isshow:false,
        })
    }

    handleChangeDateApplied = date => {
        this.setState({
            dateApplied: date,
            isshow:false,
        })
    }
    FormatDate(date) {
        let m = moment(date, 'MM-DD-YYYY');
        return (m.isValid() ? (date.getMonth()+1 + "/" + date.getDate() + "/" + date.getFullYear()) : "")
    }
    FormatDate2(date) {
        let m = moment(date, 'MM-YYYY');
        return (m.isValid() ? (date.getMonth()+1  + "/" + date.getFullYear()) : "")
    }

    
    handleChangeTitle = (e) => {
        this.setState({ titleValue: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
    };

    onChangeFirstName = (e) => {
        this.setState({ fName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
    }

    onChangeNickName = (e) => {
        this.setState({ nName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    }

    onChangeMiddleName = (e) => {
        this.setState({ mName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    }

    onChangeLastName = (e) => {
        this.setState({ lName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    }
    onChangeSuffix = (e) => {
        this.setState({ sName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    }
    handleChangeType = (e) => {
        this.setState({ typeid: e.target.value,isshow:false });
    };

    GetRegion = async()=> {
        this.setState({isloading:true});
        const params = {
            "IpAddress" : "0.0.0.0",
            "ClientId"  : "0",
            "UserId"    : "0",
            "Name"      : ""
        };
        await
        axios.post(AppConfiguration.Setting().hrisapi + "Maintenance/GetRegions",  params)
        .then(res => {
            const data = res.data
            this.setState({
                regionDDL   :   data.regions,
                isloading   :   false
            });
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true,
            })
        })
    }

    handleChangeRegion = (e) => {
        
        this.state.isshow   =   false
        if(e.length == 0) { 
            this.state.regionId     =   ""
            this.state.region   =   ""
            return
        }
        this.state.regionId     =   e[0].id
        this.state.region   =   e[0].name
        this.setState({
            isshow:false,
            provinceDDL : this.state.provinceonloadDDL.filter(x=>x.region==this.state.region)
        })
        
        //this.GetProvince();
    }

    GetProvince = async()=> {
        this.setState({isloading:true});
        const provinceParams = {
            "IpAddress" : "0.0.0.0",
            "ClientId"  : "0",
            "UserId"    : "0",
            "Region"    : ""

        };
        await
        axios
        .post(AppConfiguration.Setting().hrisapi + "Maintenance/GetProvinces",  provinceParams)
        .then(res => {
            const data = res.data;
          
            this.setState({

                provinceonloadDDL : data.provinces,
                provinceDDL : data.provinces,
                isloading   :   false
            });
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true,
            })
        })
    };
    
    GetReferralList = async() =>{
        this.setState({isloading: true})
        
        const params = {
            "IpAddress":"0.0.0.0",
           "ClientId"      :   "",
            "UserId"        :  "0"
        }
        await axios
        .post(AppConfiguration.Setting().hrisapi + "Employee/GetEmployeeProfileFilter", params)
        .then(res => {
            const data = res.data;
            ////console.log("referral")
            ////console.log(data)
            this.setState({referralLst:data.profiles.filter(x=>x.status==="ACTIVE"),isloading:false});
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }
    handledOnSearch = (e) =>{
        ////console.log("handledOnSearch")
        ////console.log(e)
        if(e===""){
            this.setState({referralDDL:[]})
        }
        else{
            this.setState({referralDDL:this.state.referralLst.filter(x => x.employeeName.toLowerCase().startsWith(e))})
            
        }
    }
    handleChangeReferral = (e) => {
        if(e.length == 0) {
            this.state.referralId     =   ""
            this.state.oReferredBy   =   ""
            return
        }
        this.state.referralId     =   e[0].id
        this.state.oReferredBy   =   e[0].employeeName
        this.setState({isshow:false,
        })
    }
    handleChangeProvince = (e) => {
        if(e.length == 0) {
            this.state.provinceId     =   ""
            this.state.provinceName   =   ""
            return
        }
        this.state.provinceId     =   e[0].id
        this.state.provinceName   =   e[0].name
        this.setState({
            isshow:false,
        })
        this.GetCity();
    }

    GetCity = async()=> {
        this.setState({isloading:true})
        const params = {
            "IpAddress" : "0.0.0.0",
            "ClientId"  : "0",
            "UserId"    : "0",
            "RegionId"  : this.state.regionId,
            "ProvinceId": this.state.provinceId,
            "Name"      : ""
        };
        await
        axios
        .post(AppConfiguration.Setting().hrisapi + "Maintenance/GetCities",  params)
        .then(res => {
            const data = res.data;
            this.setState({
                cityDDL   : data.cities,
                isloading : false
            });
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true,
            })
        })

    }

    handleChangeCity = (e) => {
        if(e.length == 0) {
            this.state.cityId     =   ""
            this.state.cityName   =   ""
            return
        }
        this.state.cityId     =   e[0].id
        this.state.cityName   =   e[0].name
        this.setState({
            isshow:false,
        })
    }

    onChangeHouseNumber = (e) => {
        // const re = /^[0-9\b]+$/;
        // if (e.target.value.replace(/[^\w\s]/gi, "") === '' || re.test(e.target.value.replace(/[^\w\s]/gi, ""))) {
        //     this.setState({ houseNumber: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, })
        // }
        this.setState({ houseNumber: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
    };

    onChangeStreet = (e) => {
        this.setState({ street: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
    };

    onChangeBarangay = (e) => {
        this.setState({ barangay: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
    };

    onChangePostalCode = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ postalCode: e.target.value,isshow:false, })
        }
        //this.setState({ postalCode: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
    };

    onChangeHPNumber = (e) => {
        //this.setState({ hpNumber: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ hpNumber: e.target.value,isshow:false, })
        }
    };

    onChangeOPNumber = (e) => {
        //this.setState({ opNumber: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ opNumber: e.target.value,isshow:false, })
        }
    };

    onChangeMobileNumber = (e) => {
        //this.setState({ mobileNumber: e.target.value,isshow:false, });
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ mobileNumber: e.target.value,isshow:false, })
        }
    };

    onChangeEmailAddress = (e) => {
        this.setState({ emailAddress: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
    };

    onChangeFacebook = (e) => {
        this.setState({ facebook: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
    };

    onChangeFacebook = (e) => {
        this.setState({ facebook: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
    };

    onChangeTwitter = (e) => {
        this.setState({ twitter: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
    };

    handleChangeCitizenship = (e) => {
        this.setState({ nationalityid: e.target.value,isshow:false, });
    };

    handleChangeReligion = (e) => {
        this.setState({ religionid: e.target.value,isshow:false, });
    };

    handleChangeGender = (e) => {
        this.setState({ genderValue: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    handleChangeCivilStatus = (e) => {
        this.setState({ civilStatusValue: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    calculate_age = (date) => {
        var today = new Date();
        var birthDate = new Date(date); 
        //////console.log("get bod-->",birthDate) // create a date object directly from `dob1` argument
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age_now--;
        }
        //////console.log('my age', age_now);
        this.setState({
            totalAge : age_now
        });
        return age_now;
    }

    handleChangeDateOfBirth = date => {
        
        this.setState({
            dateOfBirth: date,
            isshow:false,
        });
        var today = new Date();
        var birthDate = new Date(date);
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
        {
            age_now--;
        }
        this.state.totalAge = age_now
        this.state.ageMonth = date.getMonth()+1
        this.state.ageYear = birthDate.getFullYear()    
        /* if(date > null) {
            this.state.ageMonth = date.getMonth()+1
            this.state.ageYear = date.getFullYear()
        } */

    };

    handleChangeFromStart = date => {
        this.setState({
            fromStart: date,
            //toEnd :newEndDate,
            isshow:false,
        });
    };
    handleChangeToEnd = date => {
        this.setState({
            //fromStart: date,
            toEnd :date,
            isshow:false,
        });
    };

    onChangeAgeMonth(e){
        this.setState({totalAge:e.target.value.replace(/[^\w\s]/gi, "")});
    }

    onChangePlaceOfBirth = (e) => {
        this.setState({ placeOfBirth: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeHeight = (e) => {
        this.setState({ height: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeWeight = (e) => {
        this.setState({ weight: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeSkills = (e) => {
        this.setState({ sSkills: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeLSpoken = (e) => {
        this.setState({ lSpoken: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeECName = (e) => {
        this.setState({ ecName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
        /* const re = /^[0-9\b]+$/;
        if (e.target.value.replace(/[^\w\s]/gi, "") === '' || re.test(e.target.value.replace(/[^\w\s]/gi, ""))) {
            this.setState({ ecName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, })
        } */
    };

    onChangeRelationship = (e) => {
        this.setState({ relationship: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeECNumber = (e) => {
        //this.setState({ ecNumber: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ ecNumber: e.target.value,isshow:false, })
        }
          
    };

    onChangeSSS = (e) => {
        this.setState({sss: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false})
    }

    onChangeTin = (e) => {
        this.setState({tin: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false})
    }

    onChangePhilHealth = (e) => {
        this.setState({phic: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false})
    }

    onChangePagibig = (e) => {
        this.setState({pagibig: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false})
    }

    handleChangeLevel = (e) => {
        this.setState({ Levelid: e.target.value,isshow:false });
        ////console.log(e.target.value.replace(/[^\w\s]/gi, ""))
    };

    onChangeSchoolName = (e) => {
        this.setState({ SchoolName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeCourse = (e) => {
        this.setState({ Course: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeHonorsAward = (e) => {
        this.setState({ honorsAward: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeStartYear = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ StartYear: e.target.value,isshow:false, })
        }
        //this.setState({ StartYear: e.target.value,isshow:false });
    };

    onChangeEndYear = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ EndYear: e.target.value,isshow:false, })
        }
        //this.setState({ EndYear: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    handleAddEducation = (e) =>{
        let educationGrid = this.state.educationGrid
       

        let today = new Date()
        let newId = moment(today).format('HHMMSS');
        const obj = {
            "id":newId.toString(),
            "LevelId"       :   this.state.LevelId,
            "SchoolName"    :   this.state.SchoolName,
            "Course"        :   this.state.Course,
            "StartYear"     :   this.state.StartYear,
            "EndYear"       :   this.state.EndYear,
            "HonorRecieved" :   this.state.honorsAward,
            "contactPerson" :   "",
            "contactNumber" :   "",
            "isModified"    :   "0", 
            "isDeleted"    :   "0",   

            //"level":this.state.level,
        }
        /* let a =[]
        a.push(obj)

        this.state.levelDDL.forEach(element => {
            ////console.log("element")
            ////console.log(element)
            a.forEach(elements => {
                ////console.log("elements")
                ////console.log(elements)
            });
        }); */

        educationGrid.push(obj)  
        ////console.log("educationGrid") 
        ////console.log(educationGrid)    
        this.setState({
            isshow:false,
            educationGrid:educationGrid,
            LevelId:"",
            SchoolName:"",
            Course:"",
            StartYear:"",
            EndYear:"",
            honorsAward:"",
        })

        //////console.log(educationGrid)
    }
    handleRemoveEducation = (e) =>{
        let educationGrid = this.state.educationGrid.filter(x=>x.isDeleted=="0")
        this.state.educationGrid = []
        this.setState({educationGrid:educationGrid,disableRemoveEducation: educationGrid.length===0 ? true : false})
    }

    EducationGridDataModified(oldValue, newValue, id, column) {
        let disable = true
        this.state.educationGrid.map(function(item,i) {
           
            if (item.id===id){
               
                item.isModified = newValue!=oldValue ? "1" : "0"
                disable = newValue!=oldValue ? false : true
            }
        })
        //console.log(this.state.educationGrid)
        /* this.state.educationGrid.forEach(element => {
           //console.log(id)
            if (element.id===id){
                ////console.log(element.id)

               
                //console.log("asdasdasd")
                element.isModified = newValue!=oldValue ? "1" : "0"
                disable = newValue!=oldValue ? false : true
                element.SchoolName = newValue!=oldValue ? newValue : oldValue
            }
        }); */
    }

    GetLevel() {
        for (let i = 0; i < this.state.levelDDL.length; i++) {
            const obj = {
                value : this.state.levelDDL[i]["value"],
                label : this.state.levelDDL[i]["name"],
            };
            this.state.tblLevelArrLst.push(obj);
        }
    }

    onChangeERCompanyName = (e) => {
        this.setState({ erCompanyName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERCompanyAddress = (e) => {
        this.setState({ erCompanyAddress: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERPosition = (e) => {
        this.setState({ erPosition: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERCPeriodCover = (e) => {
        this.setState({ erPeriodCover: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERSalary = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ erSalary: e.target.value,isshow:false, })
        }
        //this.setState({ erSalary: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERSupervisor = (e) => {
        this.setState({ erSupervisor: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERCNumber = (e) => {
        //this.setState({ erCNumber: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ erCNumber: e.target.value,isshow:false, })
        }
    };

    onChangeERRFLeaving = (e) => {
        this.setState({ erRFLeaving: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERCIncome = (e) => {
        this.setState({ erTCIncome: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERWHTax = (e) => {
        this.setState({ erWHTax: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERYOCompensation = (e) => {
        this.setState({ erYOCompensation: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERMPAOB = (e) => {
        this.setState({ erMPAOB: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERDBenefits = (e) => {
        this.setState({ erDBenefits: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERMDeduction = (e) => {
        this.setState({ erMDeduction: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERNTSOFOC = (e) => {
        this.setState({ erNTSOFOC: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERBasicSalary = (e) => {
        this.setState({ erBasicSalary: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERTMPOB = (e) => {
        this.setState({ erTMPOB: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERTSPFOC = (e) => {
        this.setState({ erTSPFOC: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERBPFMWE = (e) => {
        this.setState({ erBPFMWE: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERHPFHWE = (e) => {
        this.setState({ erHPFHWE: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeEROPFHWE = (e) => {
        this.setState({ erOPFHWE: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERNDPFHWE = (e) => {
        this.setState({ erNDPFHWE: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeERRemarks = (e) => {
        this.setState({ erRemarks: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false, });
    };
    onChangesFreshGraduate  = (e) => {
        let employmentRecordGrid = this.state.employmentRecordGrid
        this.state.checkIsFreshGraduate = e.target.checked
        if(this.state.checkIsFreshGraduate == true) {
            
            let today = new Date()
            let newId = moment(today).format('HHMMSS');
            const obj = {
                "id":newId.toString(),
                "companyName"               :   "N/A",
                "companyAddress"            :   "N/A",
                "position"                  :   "N/A",
                "salary"                    :   "0",
                "periodCovered"             :   "N/A",
                "isModified"                :   "0",
                "supervisor"                :   this.state.erSupervisor,
                "contactNumber"             :   this.state.erCNumber,
                "reasonForLeaving"          :   "N/A",
                "taxableCompensationIncome" :   this.state.erTCIncome,
                "withholdingTax"            :   this.state.erWHTax,
                "yearOfCompensation"        :   this.state.erYOCompensation,
                "nTThirteenMonthPay"        :   this.state.erMPAOB,
                "deminimis"                 :   this.state.erDBenefits,
                "nTMandatoryDeduction"      :   this.state.erMDeduction,
                "nTSalaries"                :   this.state.erNTSOFOC,
                "basicSalary"               :   this.state.erBasicSalary,
                "taxableThirteenMonthPay"   :   this.state.erTMPOB,
                "taxableSalaries"           :   this.state.erTSPFOC,
                "basicPayMWE"               :   this.state.erBPFMWE,
                "holidayPayMWE"             :   this.state.erHPFHWE,
                "overtimePayMWE"            :   this.state.erOPFHWE,
                "nightDiffPayMWE"           :   this.state.erNDPFHWE,
                "remarks"                   :   this.state.erRemarks,
                "isDeleted"    :   "0",
            }
            employmentRecordGrid.push(obj)      
            this.setState({
                employmentRecordGrid:employmentRecordGrid,
                isshow:false,
                isEmploymentDisabled : true,
            })
            //////console.log(employmentRecordGrid)
        } else {     
            this.setState({
                employmentRecordGrid: [],
                isshow:false,
                isEmploymentDisabled : false,
            })
        }
    }

    handleAddEmploymentRecord = (e) =>{
        let employmentRecordGrid = this.state.employmentRecordGrid


        if(this.state.erCompanyName===""){
            this.setState({
                alerttype   :   "",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please enter company name.",
                fade        :   false
            });
            return
        }

        if(this.state.erCompanyAddress===""){
            this.setState({
                alerttype   :   "",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please enter company address.",
                fade        :   false
            });
            return
        }

        if(this.state.erPosition===""){
            this.setState({
                alerttype   :   "",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please enter position.",
                fade        :   false
            });
            return
        }

        if(this.state.erSalary===""){
            this.setState({
                alerttype   :   "",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please salary.",
                fade        :   false
            });
            return
        }

        if(this.state.fromStart===""){
            this.setState({
                alerttype   :   "",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please select period covered date from.",
                fade        :   false
            });
            return
        }
        if(this.state.toEnd===""){
            this.setState({
                alerttype   :   "",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please select period covered date to.",
                fade        :   false
            });
            return
        }
        /* if(this.state.erPeriodCover===""){
            this.setState({
                alerttype   :   "",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please period covered.",
                fade        :   false
            });
            return
        } */
        ////console.log(this.state.fromStart)
        ////console.log(this.state.toEnd)
        ////console.log(this.state.fromStart  + this.state.toEnd)

        let a = this.FormatDate(this.state.fromStart)
        let b = this.FormatDate(this.state.toEnd)
        let c = a + " " + b
        ////console.log(a + " "+ b)
        ////console.log(c)
        let today = new Date()
        let newId = moment(today).format('HHMMSS');
        const obj = {
            "id":newId.toString(),
            "CompanyName"               :   this.state.erCompanyName,
            "CompanyAddress"            :   this.state.erCompanyAddress,
            "Position"                  :   this.state.erPosition,
            "Salary"                    :   this.state.erSalary,
            "Supervisor"                :   this.state.erSupervisor,
            "ContactNumber"             :   this.state.erCNumber,
            "ReasonForLeaving"          :   this.state.erRFLeaving,
            "FromStart"                 : a,
            "ToEnd"                     : b,
            "PeriodCovered"             : c,
            //"periodCovered"             :   this.state.erPeriodCover,
            "TaxableCompensationIncome" :   this.state.erTCIncome,
            "WithholdingTax"            :   this.state.erWHTax,
            "YearOfCompensation"        :   this.state.erYOCompensation,
            "NTThirteenMonthPay"        :   this.state.erMPAOB,
            "Deminimis"                 :   this.state.erDBenefits,
            "NTMandatoryDeduction"      :   this.state.erMDeduction,
            "NTSalaries"                :   this.state.erNTSOFOC,
            "BasicSalary"               :   this.state.erBasicSalary,
            "TaxableThirteenMonthPay"   :   this.state.erTMPOB,
            "TaxableSalaries"           :   this.state.erTSPFOC,
            "BasicPayMWE"               :   this.state.erBPFMWE,
            "HolidayPayMWE"             :   this.state.erHPFHWE,
            "OvertimePayMWE"            :   this.state.erOPFHWE,
            "NightDiffPayMWE"           :   this.state.erNDPFHWE,
            "Remarks"                   :   this.state.erRemarks,
            "isModified"                :   "0",
            "isDeleted"    :   "0",  
        }
        //console.log(obj)
        //console.log(employmentRecordGrid)  
        employmentRecordGrid.push(obj) 
        //console.log(employmentRecordGrid)     
        this.setState({
            employmentRecordGrid:employmentRecordGrid,
            isshow:false,
            
            erCompanyName : "",
            erCompanyAddress : "",
            erPosition : "",
            erPeriodCover : "",
            erSalary : "",
            erSupervisor : "",
            erCNumber : "",
            erRFLeaving : "",
            erTCIncome : "",
            erWHTax : "",
            erYOCompensation : "",
            erMPAOB : "",
            erDBenefits : "",
            erMDeduction : "",
            erNTSOFOC: "",
            erBasicSalary : "",
            erTMPOB : "",
            erTSPFOC : "",
            erBPFMWE : "",
            erHPFHWE : "",
            erOPFHWE : "",
            erNDPFHWE : "",
            erRemarks : "",
            fromStart : "",
            toEnd : "",
        })
        //////console.log(employmentRecordGrid)
    }
    handleRemoveEmploymentRecord = (e) =>{
        let employmentRecordGrid = this.state.employmentRecordGrid.filter(x=>x.isDeleted=="0")
        this.state.employmentRecordGrid = []
        this.setState({employmentRecordGrid:employmentRecordGrid,disableRemoveEmploymentRecord: employmentRecordGrid.length===0 ? true : false})
    }

    EmploymentGridDataModified(oldValue, newValue, id, column) {
        let disable = true
        this.state.employmentRecordGrid.map(function(item,i) {
            if (item.id===id){
                item.isModified = newValue!=oldValue ? "1" : "0"
                disable = newValue!=oldValue ? false : true
            }
        })
       // this.setState({disableRemoveEducation:disable})
    }

    applicationHistoryGridDataModified(oldValue, newValue, id, column) {
        let disable = true
        this.state.applicationHistoryGrid.map(function(item,i) {
            if (item.id===id){
                item.isModified = newValue!=oldValue ? "1" : "0"
                disable = newValue!=oldValue ? false : true
            }
        })
       // this.setState({disableRemoveEducation:disable})
    }



    handleChangeRole = (e) => {
        this.setState({ Roleid: e.target.value,role: e.target.name,isshow:false });
    };
    handleChangetypeofcharacterreference=(e)=>{
        ////console.log(e.target.value.replace(/[^\w\s]/gi, ""))
        ////console.log( e.target.name)
        this.setState({ typeofcharacterreferenceid: e.target.value,isshow:false });
    }

    onChangeFBName = (e) => {
        this.setState({ fbName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeFBAge = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({fbAge: e.target.value,isshow:false})
        }
    };

    onChangeFBOccupation = (e) => {
        this.setState({ fbOccupation: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeFBCOSchool = (e) => {
        this.setState({ fbCOSchool: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeFBCNumber = (e) => {
        //this.setState({ fbCNumber: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ fbCNumber: e.target.value,isshow:false, })
        }
    };

    GetRole() {
        for (let i = 0; i < this.state.roleDDL.length; i++) {
            const obj = {
                value : this.state.roleDDL[i]["value"],
                label : this.state.roleDDL[i]["name"],
            };
            this.state.tblRoleArrLst.push(obj);
        }
        
    }
    Gettypeofcharacterreference() {
        for (let i = 0; i < this.state.typeofcharacterreference.length; i++) {
            const obj = {
                value : this.state.typeofcharacterreference[i]["value"],
                label : this.state.typeofcharacterreference[i]["name"],
            };
            this.state.tbltypeofcharacterreferenceArrLst.push(obj);
        }
        
    }

    handleAddFamilybackground = (e) =>{
        let familyBackgroundGrid = this.state.familyBackgroundGrid


        let today = new Date()
        let newId = moment(today).format('HHMMSS');
        const obj = {
            "id":newId.toString(),
            "RoleId"        :   this.state.RoleId,
            "Name"          :   this.state.fbName,
            "ContactNumber" :   this.state.fbCNumber,
            "Age"           :   this.state.fbAge,
            "Occupation"    :   this.state.fbOccupation,
            "Company"       :   this.state.fbCOSchool,
            "UserId"        :   this.state.userinfo.userid,
            "isModified"    :   "0",
            "isDeleted"     :   "0",  
            "role"          :   this.state.role,
        }
        familyBackgroundGrid.push(obj)      
        this.setState({familyBackgroundGrid:familyBackgroundGrid,isshow:false})
    }
    handleRemoveBackground = (e) =>{
        this.state.familyBackgroundGrid.forEach((itm,idx) => {
            if(idx<=5){
                itm.isDeleted="0"
            }
            
        })
        let familyBackgroundGrid = this.state.familyBackgroundGrid.filter(x=>x.isDeleted=="0")
        this.setState({familyBackgroundGrid:familyBackgroundGrid,disableBackground: familyBackgroundGrid.length===0 ? true : false})
    }

    FamilyBackgroundGridDataModified(oldValue, newValue, id, column) {
        let disable = true
        this.state.familyBackgroundGrid.map(function(item,i) {
            if (item.id===id){
                item.isModified = newValue!=oldValue ? "1" : "0"
                disable = newValue!=oldValue ? false : true
            }
        })
       // this.setState({disableRemoveEducation:disable})
    }



    handleChangeJobOpening = (e) => {
        
        if(e.target.value === "9" ||  e.target.value === "7"){
            this.refs.refReferredBy.clear()
            this.setState({
                jobSourceid: e.target.value,
                disablereferral:false,
                referealOthersTA : false,
                referealOthersTXT : true,
                isshow:false,
            })
        }else if(e.target.value === "10"){
            this.refs.refReferredBy.clear()
            this.setState({
                jobSourceid: e.target.value,
                disablereferral:false,
                referealOthersTA : true,
                referealOthersTXT : false,
                isshow:false,
            })
        }else if(e.target.value!=="7" ||  e.target.value === "9" || e.target.value === "10"){
            this.refs.refReferredBy.clear()
            this.setState({
                jobSourceid: e.target.value,
                isshow:false,
                disablereferral:true,
                referealOthersTA : true,
                referealOthersTXT : false,
                isshow:false,
            })
        }
    }

    onChangeOthersRefferedBy = (e) => {
        //console.log(e.target.value.replace(/[^\w\s]/gi, ""))
        this.setState({ oReferredBy: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };
    

    
    onChangeORelativeYes  = (e) => {
        this.state.checkORelativeYes = e.target.checked
        if(this.state.checkORelativeYes == true) {
            this.setState({
                checkORelativeNo    :   false,
                disabledRelative    : false,
            })
        }
    }
    
    onChangeORelativeNo  = (e) => {
        this.state.checkORelativeNo = e.target.checked
        if(this.state.checkORelativeNo == true) {
            this.setState({
                checkORelativeYes   :   false,
                disabledRelative    : true,
                oRelativeName : "",
                oCNumber : "",
                oRelationship : "",
                oJobTitle : "",
            })
        }
    }

    onChangeORelativeName = (e) => {
        this.setState({ oRelativeName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeOCNumber = (e) => {
        //this.setState({ oCNumber: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ oCNumber: e.target.value,isshow:false, })
        }
    };

    onChangeORelationship = (e) => {
        this.setState({ oRelationship: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeOJobTitle = (e) => {
        this.setState({ oJobTitle: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };
    
    onChangeOthersConvictedYes  = (e) =>{
        this.state.checkConvictedYes = e.target.checked
        if(this.state.checkConvictedYes == true) {
            this.setState({
                checkConvictedNo  :   false,
                disabledConvicted         :   false,
            })
        }
    }
    
    onChangeOthersConvictedNo  = (e) =>{
        this.state.checkConvictedNo = e.target.checked
        if(this.state.checkConvictedNo == true) {
            this.setState({
                disabledConvicted  :   true,
                checkConvictedYes         :   false,
                crime : "",
            })
        }
    }
    
    onChangeOthersLaborUnionYes  = (e) =>{
        this.state.checkLaborUnionYes = e.target.checked
        if(this.state.checkLaborUnionYes == true) {
            this.setState({
                checkLaborUnionNo  :   false,
                disabledLaborUnion  :   false,
            })
        }
    }

    onChangeOCrime = (e) => {
        this.setState({ oCrime: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };
    
    onChangeOthersLaborUnionNo  = (e) =>{
        this.state.checkLaborUnionNo = e.target.checked
        if(this.state.checkLaborUnionNo == true) {
            this.setState({
                checkLaborUnionYes  :   false,
                disabledLaborUnion  :   true,
            })
        }
    }

    onChangeLUDetails = (e) => {
        this.setState({ luDetails: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };
    
    onChangeOthersChronicDiseaseYes  = (e) =>{
        this.state.checkChronicDiseaseYes = e.target.checked
        if(this.state.checkChronicDiseaseYes == true) {
            this.setState({
                checkChronicDiseaseNo  :   false,
                disabledDisease  :   false,
            })
        }
    }
    
    onChangeOthersChronicDiseaseNo  = (e) =>{
        this.state.checkChronicDiseaseNo = e.target.checked
        if(this.state.checkChronicDiseaseNo == true) {
            this.setState({
                checkChronicDiseaseYes  :   false,
                disabledDisease :   true,
                diagnoseDeseaseId : "",
            })
        }
    }

    handleChangeDisease = (e) => {
        this.setState({ diagnoseDeseaseid: e.target.value,chronicDisease: e.target.name,isshow:false });
    };

    GetJobOpening = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userid
        };
        await axios.post(AppConfiguration.Setting().hrisapi + "Maintenance/GetJobOpenings",  params)
        .then(res => {
            const data = res.data;
            let jobOpeningDDL = []
            let tblJobOpeningArrLst = []
            jobOpeningDDL.push({"value":"","name":"Select Job Opening"})
            data.jobOpenings.map(function(itm){
                jobOpeningDDL.push({"value":itm.id,"name":itm.name})
                tblJobOpeningArrLst.push({"value" : itm.id,"label" : itm.name})
            })
            this.setState({jobOpeningDDL:jobOpeningDDL,tblJobOpeningArrLst:tblJobOpeningArrLst});
        })
        this.GetReligions();
    }

    GetDisease() {
        for (let i = 0; i < this.state.diseaseDDL.length; i++) {
            const obj = {
                value : this.state.diseaseDDL[i]["value"],
                label : this.state.diseaseDDL[i]["name"],
            };
            this.state.tblDiseaseArrLst.push(obj);
        }
        
    }
    
    handleAddOthers = (e) =>{
        if(this.state.checkORelativeYes === true) {
            if(this.state.oRelativeName === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter name",
                    fade:true
                });
                return
            }
            if(this.state.oCNumber === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter contact number",
                    fade:true
                });
                return
            }
            if(this.state.oRelationship === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter relationship",
                    fade:true
                });
                return
            }
            if(this.state.oJobTitle === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter job title",
                    fade:true
                });
                return
            }
        }
        
        if(this.state.checkConvictedYes === true) {
            if(this.state.oCrime === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter details",
                    fade:true
                });
                return
            }
        }
        
        if(this.state.checkLaborUnionYes === true) {
            if(this.state.luDetails === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter details",
                    fade:true
                });
                return
            }
        }
        
        if(this.state.checkChronicDiseaseYes === true) {
            if(this.state.diagnoseDeseaseId === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please select details",
                    fade:true
                });
                return
            }
        }

        let othersGrid = this.state.othersGrid

        let today = new Date()
        let newId = moment(today).format('HHMMSS');
        const obj = {
            "id":newId.toString(),
            "applicationFormId":"1",
            "JobSourceId":this.state.jobSourceId,
            "RefferedBy":this.state.oReferredBy,
            "HasCompanyRelative":(this.state.checkORelativeYes)? "1" : "0",
            "RelativeName":this.state.oRelativeName,
            "RelativeRelation":this.state.oRelationship,
            "RelativeContactNumber":this.state.oCNumber,
            "RelativePosition":this.state.oJobTitle,
            "isCrimeConvicted":(this.state.checkConvictedYes)? "1" : "0",
            "IsCrimeConvicted":this.state.oCrime,
            "IsLaborUnion":(this.state.checkLaborUnionYes)? "1" : "0",
            "LaborUnionDescription":this.state.luDetails,
            "DiagnoseDeseaseId":this.state.diagnoseDeseaseId,
            "UserId":this.state.userinfo.userid,
            "isModified"    :   "0",
            "isDeleted"    :   "0",  
            "jobopening"       :   this.state.jobSource,
            "diagnoseDesease":this.state.chronicDisease
        }
        othersGrid.push(obj)      
        this.setState({
            othersGrid:othersGrid,
            isshow:false,
            jobSourceId : "",
            checkConvictedYes : false,
            checkConvictedNo : true,
            oCrime : "",
            disabledConvicted : true,
            oReferredBy : "",
            checkLaborUnionYes : false,
            checkLaborUnionNo : true,
            disabledLaborUnion : true,
            luDetails : "",
            checkChronicDiseaseYes : false,
            checkChronicDiseaseNo : true,
            disabledDisease : true,
            diagnoseDeseaseId : "",
        })
        //////console.log(othersGrid)
    }
    handleRemoveOthers = (e) =>{
        let othersGrid = this.state.othersGrid.filter(x=>x.isDeleted=="0")
        this.state.othersGrid = []
        this.setState({othersGrid:othersGrid,disableOthers: othersGrid.length===0 ? true : false})
    }

    OtherGridDataModified(oldValue, newValue, id, column) {
        let disable = true
        this.state.othersGrid.map(function(item,i) {
            if (item.id===id){
                item.isModified = newValue!=oldValue ? "1" : "0"
                disable = newValue!=oldValue ? false : true
            }
        })
       // this.setState({disableRemoveEducation:disable})
    }


    onChangeReferenceName = (e) => {
        this.setState({ referenceName: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeReferencOccupation = (e) => {
        this.setState({ referenceOccupation: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeReferenceCOSchool = (e) => {
        this.setState({ referenceCOSchool: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };

    onChangeReferenceCNumber = (e) => {
        //this.setState({ referenceCNumber: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ referenceCNumber: e.target.value,isshow:false, })
        }
         
    };

    handleAddReference = (e) =>{
        // if(this.state.typeofcharacterreferenceId === "") {
        //     this.setState({
        //         isloading:false,
        //         alerttype:"Error!",
        //         isshow:true,
        //         color:"danger",
        //         message: "please enter type of character reference",
        //         fade:true
        //     });
        //     return
        // }
        // if(this.state.referenceName === "") {
        //     this.setState({
        //         isloading:false,
        //         alerttype:"Error!",
        //         isshow:true,
        //         color:"danger",
        //         message: "please enter name",
        //         fade:true
        //     });
        //     return
        // }
        // if(this.state.referenceOccupation === "") {
        //     this.setState({
        //         isloading:false,
        //         alerttype:"Error!",
        //         isshow:true,
        //         color:"danger",
        //         message: "please enter occupation",
        //         fade:true
        //     });
        //     return
        // }
        // if(this.state.referenceCOSchool === "") {
        //     this.setState({
        //         isloading:false,
        //         alerttype:"Error!",
        //         isshow:true,
        //         color:"danger",
        //         message: "please enter company or school",
        //         fade:true
        //     });
        //     return
        // }
        // if(this.state.referenceCNumber === "") {
        //     this.setState({
        //         isloading:false,
        //         alerttype:"Error!",
        //         isshow:true,
        //         color:"danger",
        //         message: "please enter contact number",
        //         fade:true
        //     });
        //     return
        // }
        
        let referenceGrid = this.state.referenceGrid

        let today = new Date()
        let newId = moment(today).format('HHMMSS');
        const obj = {
            "id":newId.toString(),
            "typeId" : this.state.typeofcharacterreferenceId,
            "typeofCharacterReferenceName" : this.state.typeofcharacterreferenceName,
            "name"          :  this.state.referenceName,
            "contactNumber" :   this.state.referenceCNumber,
            "occupation"    :   this.state.referenceOccupation,
            "company"       :   this.state.referenceCOSchool,
            "userId"        :this.state.userinfo.userid,
            "isDeleted"    :   "0",  
        }
        ////console.log("obj")
        ////console.log(obj)
        referenceGrid.push(obj)    
        ////console.log("referenceGrid")  
        ////console.log(referenceGrid)  
        this.setState({
            referenceGrid:referenceGrid,
            isshow:false,
            typeofcharacterreferenceId :"",
            referenceName : "",
            referenceOccupation : "",
            referenceCOSchool : "",
            referenceCNumber : "",
        })
        ////console.log(referenceGrid)
    }
    handleRemoveReference = (e) =>{
        let referenceGrid = this.state.referenceGrid.filter(x=>x.isDeleted=="0")
        this.state.referenceGrid = []
        this.setState({referenceGrid:referenceGrid,disableReference: referenceGrid.length===0 ? true : false})
    }

    ReferenceGridDataModified(oldValue, newValue, id, column) {
        let disable = true
        this.state.referenceGrid.map(function(item,i) {
            if (item.id===id){
                item.isModified = newValue!=oldValue ? "1" : "0"
                disable = newValue!=oldValue ? false : true
            }
        })
       // this.setState({disableRemoveEducation:disable})
    }
    
    onChangeDisclaimer  = (e) =>{
        this.state.checkDisclaimer = e.target.checked
        if(this.state.checkDisclaimer == true) {
            this.setState({
                disablebutton :   false,
            })
        } else {
            this.setState({
                disablebutton :   true,
            })
        }
    }
    
    handleClickStatus = async(statusId) => {
        this.setState({loading : true})
        const { s3NewId } = this.state;

        //console.log(this.state.userinfo[0].userid)
        
        
        if(this.state.newImage === ""){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please upload ID picture",
                fade:true
            });
            return
        }else{
            this.setState({
                isloading:false,
                alerttype:"",
                isshow:false,
                color:"",
                message: "",
                fade:false
            });
            
        };
        if(this.state.titleValue === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please select name title",
                fade:true
            });
            return
        };
        if(this.state.nName === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter nick name",
                fade:true
            });
            return
        };
        if(this.state.fName === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter first name",
                fade:true
            });
            return
        };
        if(this.state.lName === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter last name",
                fade:true
            });
            return
        };
        if(this.state.dateOfBirth === ""){
            this.state.this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please select date of birth",
                fade:true
            });
            return
        };
        if(this.state.sss === ""){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter SSS number",
                fade:true
            });
            return
        };
        if(this.state.tin === ""){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter TIN number",
                fade:true
            });
            return
        };
        if(this.state.phic === ""){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter PHILHEALTH number",
                fade:true
            });
            return
        };
        if(this.state.pagibig === ""){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter PAGIBIG number",
                fade:true
            });
            return
        };
        if(this.state.typeId === "") {
           this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please select address type",
                fade:true
            });
            return
        }
        if(this.state.regionId === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please select region",
                fade:true
            });
            return
        }
        if(this.state.provinceId === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please select province",
                fade:true
            });
            return
        }
        if(this.state.cityId === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please select city",
                fade:true
            });
            return
        }
        if(this.state.houseNumber === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter houseNumber",
                fade:true
            });
            return
        }
        if(this.state.street === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter street",
                fade:true
            });
            return
        }
        if(this.state.barangay === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter barangay",
                fade:true
            });
            return
        }
        if(this.state.postalCode === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter postalCode",
                fade:true
            });
            return
        }
        if(this.state.emailAddress === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter email address",
                fade:true
            });
            return
        }
        if(this.state.mobileNumber === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter mobile number",
                fade:true
            });
            return
        }
        if(this.state.hpNumber === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter home phone number",
                fade:true
            });
            return
        }
        if(this.state.facebook === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter facebook",
                fade:true
            });
            return
        }
        if(this.state.twitter === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter twitter",
                fade:true
            });
            return
        }
        if(this.state.nationalityId === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please select nationality",
                fade:true
            });
            return
        }
        if(this.state.religionId === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please select religion",
                fade:true
            });
            return
        }
        if(this.state.genderValue === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please select gender",
                fade:true
            });
            return
        }
        if(this.state.civilStatusValue === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please select civil status",
                fade:true
            });
            return
        }
        if(this.state.dateOfBirth === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please select date of birth",
                fade:true
            });
            return
        }
        if(this.state.placeOfBirth === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter place of birth",
                fade:true
            });
            return
        }
        if(this.state.height === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter height",
                fade:true
            });
            return
        }
        if(this.state.weight === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter weight",
                fade:true
            });
            return
        }
        if(this.state.sSkills === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter special skills",
                fade:true
            });
            return
        }
        if(this.state.lSpoken === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter language spoken",
                fade:true
            });
            return
        }
        if(this.state.ecName === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter emergency contact name",
                fade:true
            });
            return
        }
        if(this.state.relationship === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter emergency contact relation",
                fade:true
            });
            return
        }
        if(this.state.ecNumber === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter emergency contact number",
                fade:true
            });
            return
        }
        if(this.state.tin === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter tin number",
                fade:true
            });
            return
        }
        if(this.state.sss === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter sss number",
                fade:true
            });
            return
        }
        if(this.state.phic === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter philhealth number",
                fade:true
            });
            return
        }
        if(this.state.pagibig === "") {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please enter pagibig number",
                fade:true
            });
            return
        };
        if(18 > this.state.totalAge){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "Age below 18 is not valid",
                fade:true
            });
            return
        };

        if(this.IsValidMobile(this.state.mobileNumber)){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "Mobile number should start with 09 followed by 9 digits.",
                fade:true
            });
            return
        }
        if(this.IsValidMobile(this.state.ecNumber)){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "Mobile number should start with 09 followed by 9 digits.",
                fade:true
            });
            return
        }

        // if(this.state.uploadResume === ""){
        //     this.setState({
        //         isloading:false,
        //         alerttype:"Error!",
        //         isshow:true,
        //         color:"danger",
        //         message: "please upload resume",
        //         fade:true
        //     });
        //     return
        // };

        
        let educationGridtemp = this.state.educationGrid
        let b = educationGridtemp.filter((item) => item.SchoolName !== "");
        if(b.length === 0){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under school name",
                fade:true
            });
        //     return
        }else if(b.length < 2){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "fields under school name must be aleast 2",
                fade:true
            });
            return
        };
        let c = educationGridtemp.filter((item) => item.Course !== "");
        if(c.length === 0){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under Course",
                fade:true
            });
            return
        }else if(c.length < 2){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "fields under Course must be aleast 2",
                fade:true
            });
            return
        };
        let d = educationGridtemp.filter((item) => item.StartYear !== "");
        if(d.length === 0){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under start year",
                fade:true
            });
            return
        }else if(d.length < 2){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "fields under start year must be aleast 2",
                fade:true
            });
            return
        };
        let e = educationGridtemp.filter((item) => item.EndYear !== "");
        if(e.length === 0){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under end year",
                fade:true
            });
            return
        }else if(e.length < 2){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "fields under end year must be aleast 2",
                fade:true
            });
            return
        };

        if(!this.state.educationGrid.length) {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under education",
                fade:true
            });
            return
        };
       
        if(!this.state.employmentRecordGrid.length) {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input some fields under employment record",
                fade:true
            });
            return
        };
        
        if(!this.state.familyBackgroundGrid.length) {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under family background",
                fade:true
            });
            return
        }
        let familyBackgroundGridtmp = this.state.familyBackgroundGrid
        let a = familyBackgroundGridtmp.filter((item) => item.name !== "");
        if(a.length === 0){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under family Background NAME",
                fade:true
            });
            return
        };
        let aa = familyBackgroundGridtmp.filter((item) => item.contactNumber !== "");
        if(aa.length === 0){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under family Background contact number",
                fade:true
            });
            return
        };
        let aaa = familyBackgroundGridtmp.filter((item) => item.age !== "");
        if(aaa.length === 0){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under family Background age",
                fade:true
            });
            return
        };
        let aaaa = familyBackgroundGridtmp.filter((item) => item.occupation !== "");
        if(aaaa.length === 0){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under family Background occupation",
                fade:true
            });
            return
        };
        let aaaaa = familyBackgroundGridtmp.filter((item) => item.company !== "");
        if(aaaaa.length === 0){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under family Background company",
                fade:true
            });
            return
        };

        

        if(!this.state.referenceGrid.length) {
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "please input all fields under reference",
                fade:true
            });
            return
        }else if (this.state.referenceGrid.length < 3){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "character references must be 3 or more",
                fade:true
            });
            return
        }

        // w update submit
        let neweducationGrid = []
        this.state.educationGrid.map(function(itm,i) {
            
            neweducationGrid.push({
                "LevelId"       :   itm.LevelId,
                "ContactPerson" :   itm.ContactPerson,
                "ContactNumber" :   itm.ContactPerson,
                "SchoolName"    :   itm.SchoolName,
                "Course"        :   itm.Course,
                "StartYear"     :   itm.StartYear,
                "EndYear"       :   itm.EndYear,
                "HonorRecieved" :   itm.HonorRecieved,
            })
        })          

        let newemploymentRecordGrid = []
        this.state.employmentRecordGrid.map(function(itm,i) {
            let a = itm.fromStart
            let b = itm.toEnd
            let c = a + " " + b
            newemploymentRecordGrid.push({
                "CompanyName"               :   itm.CompanyName,
                "CompanyAddress"            :   itm.CompanyAddress,
                "Position"                  :   itm.Position,
                "Salary"                    :   itm.Salary,
                "Supervisor"                :   itm.Supervisor,
                "ContactNumber"             :   itm.ContactNumber,
                "ReasonForLeaving"          :   itm.ReasonForLeaving,
                "PeriodCovered"             :   itm.PeriodCovered,
                "TaxableCompensationIncome" :   itm.TaxableCompensationIncome,
                "WithholdingTax"            :   itm.WithholdingTax,
                "YearOfCompensation"        :   itm.YearOfCompensation,
                "NTThirteenMonthPay"        :   itm.NTThirteenMonthPay,
                "Deminimis"                 :   itm.Deminimis,
                "NTMandatoryDeduction"      :   itm.NTMandatoryDeduction,
                "NTSalaries"                :   itm.NTSalaries,
                "BasicSalary"               :   itm.BasicSalary,
                "TaxableThirteenMonthPay"   :   itm.TaxableThirteenMonthPay,
                "TaxableSalaries"           :   itm.TaxableSalaries,
                "BasicPayMWE"               :   itm.BasicPayMWE,
                "HolidayPayMWE"             :   itm.HolidayPayMWE,
                "OvertimePayMWE"            :   itm.OvertimePayMWE,
                "NightDiffPayMWE"           :   itm.NightDiffPayMWE,
                "Remarks"                   :   itm.Remarks,
                "FromStart"                 :  itm.FromStart,
                "ToEnd"                     :  itm.ToEnd,
            })
        })                    

        let newfamilyBackgroundGrid = []
        this.state.familyBackgroundGrid.map(function(itm,i) {
            newfamilyBackgroundGrid.push({
                "RoleId"        :   itm.RoleId,
                "Name"          :   itm.Name,
                "ContactNumber" :   itm.ContactNumber,
                "Age"           :   itm.Age,
                "Occupation"    :   itm.Occupation,
                "Company"       :   itm.Company,
                "UserId":itm.UserId,
                //"ole"          :   itm.role,
            })
        })             

        /*VALIDATE OTHERS*/
         let newothersGrid = []
        if(this.state.checkORelativeYes === true) {
            if(this.state.oRelativeName === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter name",
                    fade:true
                });
                return
            }
            if(this.state.oCNumber === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter contact number",
                    fade:true
                });
                return
            }
            if(this.state.oRelationship === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter relationship",
                    fade:true
                });
                return
            }
            if(this.state.oJobTitle === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter job title",
                    fade:true
                });
                return
            }
        }
        
        if(this.state.checkConvictedYes === true) {
            if(this.state.oCrime === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter details",
                    fade:true
                });
                return
            }
        }
        
        if(this.state.checkLaborUnionYes === true) {
            if(this.state.luDetails === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please enter details",
                    fade:true
                });
                return
            }
        }
        
        if(this.state.checkChronicDiseaseYes === true) {
            if(this.state.diagnoseDeseaseId === "") {
                this.setState({
                    isloading:false,
                    alerttype:"Error!",
                    isshow:true,
                    color:"danger",
                    message: "please select details",
                    fade:true
                });
                return
            }
        }

        newothersGrid.push({

            // "JobSourceId":this.state.jobSourceId,
            // "RefferedBy":this.state.oReferredBy,
            // "HasCompanyRelative":(this.state.checkORelativeYes)? "1" : "0",
            // "RelativeName":this.state.oRelativeName,
            // "RelativeRelation":this.state.oRelationship,
            // "RelativePosition":this.state.oJobTitle,
            // "RelativeContactNumber":this.state.oCNumber,
            // "IsCrimeConvicted":(this.state.checkConvictedYes)? "1" : "0",
            // "CrimeDescription":this.state.oCrime,
            // "IsLaborUnion":(this.state.checkLaborUnionYes)? "1" : "0",
            // "LaborUnionDescription":this.state.luDetails,
            // "DiagnoseDeseaseId":this.state.diagnoseDeseaseId,
            // "UserId":this.state.userinfo.userid

            "JobSourceId":"",//this.state.jobSourceId,
            "RefferedBy":"",//this.state.oReferredBy,
            "HasCompanyRelative":(this.state.checkORelativeYes)? "1" : "0",
            "RelativeName":"",//this.state.oRelativeName,
            "RelativeRelation":"",//this.state.oRelationship,
            "RelativePosition":"",//this.state.oJobTitle,
            "RelativeContactNumber":"",//this.state.oCNumber,
            "IsCrimeConvicted":(this.state.checkConvictedYes)? "1" : "0",
            "CrimeDescription":"",//this.state.oCrime,
            "IsLaborUnion":(this.state.checkLaborUnionYes)? "1" : "0",
            "LaborUnionDescription":"",//this.state.luDetails,
            "DiagnoseDeseaseId":"",//this.state.diagnoseDeseaseId,
            //"UserId":this.state.UserId
        })
                 
        /*END OTHERS*/

        let newreferenceGrid = []
        this.state.referenceGrid.map(function(itm,i) {
            newreferenceGrid.push({
                "TypeId" : itm.TypeId,
                "Name"          :  itm.Name,
                "ContactNumber" :   itm.ContactNumber,
                "Occupation"    :   itm.Occupation,
                "Company"       :   itm.Company,
                "UserId":itm.UserId
            })
        })
        

       this.setState({isloading:true})

        let f = new Date();
        let createddate = moment(f).format('MM/DD/YYYY');
        let w = f.toLocaleTimeString()
        let today = new Date()
        let clientId = moment(today).format('MMYYYYhhmmss');
        
        const now = new Date();
        // now.setSeconds(now.getSeconds() + 1);
        now.setSeconds(now.getSeconds());
        let newId = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}` ;
        //console.log("ApplicationFormEdit handleClickStatus newId:", newId);
        
        const obj = {
            // "newId"                     : newId,
            "newId"                     : this.globalNewId,
            "IpAddress"                 : "0.0.0.0",
            "CandidateProfileId"        : this.state.CandidateProfileId,
            "ProfileId"                 : "0",
            //"headerId"                  : this.state.headerId,
            "UserId"                    : this.state.userinfo[0].userid,
            "StatusId"                  : statusId,
            "PositionId"                : this.state.positionId,
            "DateApplied"               : this.state.dateApplied,
            "IdPicture"                 : this.state.fileImage,
            "Resume"                    : this.state.uploadResume,
            "Title"                     : this.state.titleValue,
            "FirstName"                 : this.state.fName,
            "NickName"                  : this.state.nName,
            "MiddleName"                : this.state.mName,
            "LastName"                  : this.state.lName,
            "SuffixName"                : this.state.sName,
            "EmailAddress"              : this.state.emailAddress,
            "MobileNumber"              : this.state.mobileNumber,
            "OfficeNumber"              : this.state.opNumber,
            "HomePhoneNumber"           : this.state.hpNumber,
            "Facebook"                  : this.state.facebook,
            "Twitter"                   : this.state.twitter,
            "NationalityId"             : this.state.nationalityId,
            "ReligionId"                : this.state.religionId,
            "Gender"                    : this.state.genderValue,
            "CivilStatus"               : this.state.civilStatusValue,
            "DateOfBirth"               : this.FormatDate(this.state.dateOfBirth),
            "AgeYear"                   : this.state.ageYear,
            "AgeMonth"                  : this.state.ageMonth,
            "PlaceOfBirth"              : this.state.placeOfBirth,
            "Height"                    : this.state.height,
            "Weight"                    : this.state.weight,
            "SpecialSkills"             : this.state.sSkills,
            "LanguageSpoken"            : this.state.lSpoken,
            "EmergencyContactName"      : this.state.ecName,
            "EmergencyContactRelation"  : this.state.relationship,
            "EmergencyContactNumber"    : this.state.ecNumber,
            "Hobbies"                   : "",
            "TINNumber"                 : this.state.tin,
            "SSSNumber"                 : this.state.sss,
            "PHICNumber"                : this.state.phic,
            "HDMFNumber"                : this.state.pagibig,
            "LivingArrangementId"       : this.state.arrangementId,
            "Arrangement"               : this.state.arrangement,
            "BloodTypeId"               : this.state.bloodtypeId,
            "BloodType"                 : this.state.bloodtype,
            "timestamp"                 : w,
            "createddate"               : createddate,
            "isDeleted"                 : "0",

            "applicantAddresses" :[{
                "TypeId"      : this.state.typeId,
                "RegionId"    : this.state.regionId,
                "Region"      : this.state.region,
                "ProvinceId"  : this.state.provinceId,
                "Province"    : this.state.provinceName,
                "CityId"      : this.state.cityId,
                "City"        : this.state.cityName,
                "HouseNumber" : this.state.houseNumber,
                "StreetName"  : this.state.street,
                "Barangay"    : this.state.barangay,
                "PostalCode"  : this.state.postalCode,
            }],
            "educationAttainments"  : neweducationGrid,
            "employmentHistories"   : newemploymentRecordGrid,
            "familyBackgrounds"     : newfamilyBackgroundGrid,
            "others"                : newothersGrid,
            "characterReferences"   : newreferenceGrid,
        };
        
        //console.log("obj")
        //console.log(obj)

        const params = {
            "_collection" : "CandidatesProfile",
            "doc_data"    : obj,
            "_id"         :this.state.headerId,
        }

        //console.log(" params update")
        //console.log(params)

        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/update_one", params)
        .then(res => {
            let data = res.data
            //console.log(data)
            //console.log(res.status)
            if(res.status === 200){
               // this.setState({navigate : true})
                
                this.uploadCandidatePic();
            }
       
       
        }).catch(error =>{
            //console.log("3")
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
            return
        })

        

    };

    
    

    uploadCandidatePic = () => {
        const { fileImage } = this.state;
        
        //console.log("Current globalNewId in handleClickStatus:", this.globalNewId);
    
        if (!fileImage || !fileImage.name) {
            alert("No image file selected. Please select a valid image file.");
            return;
        }
    
        const filename = fileImage.name;
        const validFilenamePattern = /^[a-zA-Z0-9._-]+$/;
        if (!validFilenamePattern.test(filename)) {
            alert("Invalid filename. Please use alphanumeric characters, dots, underscores, or hyphens only and reupload your file.");
            this.setState({loading : false})
            return;
        }
    
        const now = new Date();
        now.setSeconds(now.getSeconds() -1);
        const newId = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
    
        const fileExtension = filename.split('.').pop();
        const baseFilename = filename.substring(0, filename.lastIndexOf('.'));
    
        // const newFilename = `${baseFilename}-${newId}.${fileExtension}`;
        const newFilename = `${baseFilename}-${this.globalNewId}.${fileExtension}`;
    
        const S3_BUCKET = 'job-space-resume-pics-noser-cdr';
        const REGION = 'us-east-1';
        const ACCESS_KEY = AppConfiguration.Setting().accessKeyId;
        const SECRET_KEY = AppConfiguration.Setting().secretAccessKey;
    
        AWS.config.update({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_KEY,
            region: REGION,
        });
    
        const s3 = new AWS.S3();
        const params = {
            Bucket: S3_BUCKET,
            Key: newFilename,
            Body: fileImage,
            ACL: 'bucket-owner-full-control',
        };
    
        s3.upload(params, (err, data) => {
            if (err) {
                //console.log("Error uploading file:", err);
                alert("Error uploading file.");
                this.setState({loading: false})
            } else {
                //console.log("Successfully uploaded file:", data);
                this.setState({
                    showAlert: true,
                    isInactive: false,
                    selectedRoleId: null
                });
                this.setState({
                    isloading: false,
                    alerttype: "Success!",
                    isshow: true,
                    color: "success",
                    message: "Successfully uploaded candidate picture.",
                    fade: true
                });
                // this.fileInputRef.current.value = null;
                if (this.fileInputRef) {
                    this.fileInputRef = null;
                }
                this.uploadFile()
                setTimeout(() => {
                    this.setState({ showAlert: false });
                }, 3000);
            }
        });
    };

    uploadFile = () => {
        const { uploadResume, s3NewId } = this.state;

        //console.log("Current globalNewId in uploadFile:", this.globalNewId);
    
        if (!uploadResume || !uploadResume.name) {
            alert("No resume file selected. Please select a valid resume file.");
            return;
        }
    
        const filename = uploadResume.name;
        const validFilenamePattern = /^[a-zA-Z0-9._-]+$/;
        if (!validFilenamePattern.test(filename)) {
            alert("Invalid filename. Please use alphanumeric characters, dots, underscores, or hyphens only and reupload your file.");
            this.setState({loading : false})
            return;
        }
    
        const now = new Date();
        // now.setSeconds(now.getSeconds());
        const newId = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
        const fileExtension = filename.split('.').pop();
        const baseFilename = filename.substring(0, filename.lastIndexOf('.'));
        // const newFilename = `${baseFilename}-${newId}.${fileExtension}`;
        const newFilename = `${baseFilename}-${this.globalNewId}.${fileExtension}`;
    
        const S3_BUCKET = 'job-space-bucket-noser-cdr';
        const REGION = 'us-east-1';
       const ACCESS_KEY = AppConfiguration.Setting().accessKeyId;
        const SECRET_KEY = AppConfiguration.Setting().secretAccessKey;
    
        AWS.config.update({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_KEY,
            region: REGION,
        });
    
        const s3 = new AWS.S3();
        const params = {
            Bucket: S3_BUCKET,
            Key: newFilename,
            Body: uploadResume,
            ACL: 'bucket-owner-full-control',
        };
    
        s3.upload(params, (err, data) => {
            if (err) {
                //console.log("Error uploading file:", err);
                alert("Error uploading file.");
                this.setState({loading: false})
            } else {
                //console.log("Successfully uploaded file:", data);
                this.setState({
                    isloading: false,
                    alerttype: "Success!",
                    isshow: true,
                    color: "success",
                    message: "Successfully Saved",
                    fade: true
                });
                if (this.fileInputRef/* .current */) {
                    this.fileInputRef = null;
                }
                /* console.log("window.location")
                   //window.location.href='/ApplicationFormView'
                   setTimeout(() => {
                    this.setState({ showAlert: false });
                }, 3000); */
                this.setState({ showModal: true, loading:false });
                //this.setState({ navigate: true });
            }
        });
    };

    lipatViewBTNmodal=()=>{
        console.log("window.location")
        //window.location.href='/ApplicationFormView'
        setTimeout(() => {
         this.setState({ showAlert: false });
        }, 5000);
     this.setState({ navigate: true });
    }

    // getprofileImage=(data)=>{
    //     ////console.log("getprofileImage 111111111111111")
    //     let filter_data = {
    //         "isDeleted" : "0", 
    //         "userId" : this.state.userinfo[0].userid,
    //         //"isDeleted" : "0",
    //         /*  "firstName" : firstName,
    //         "lastName"  : lastName, */
    //     }
        
    //     const Params = {
    //         "_collection" : "imageChecklist",
    //         "filter_data" : filter_data
    //     }
    //     ////console.log("Params")
    //     ////console.log(Params)
    //     //////console.log("s")
    //         axios
    //         .post(AppConfiguration.Setting().jobspaceapi +"action/get", Params)
    //     .then(res => {
    
    //         //////console.log("res.data")
    //         //////console.log(res)
    
    //         let dataTmp = []
    //         let a
    //         let dataaa = res.data
    //         //////console.log("data ")
    //         //////console.log(dataaa)
    //         let newstr2=""
    //         dataaa.imageChecklist.map(function(itm,i){
    //             let strJson = "{" + itm.substring(46, itm.length)
    //             let strJson2 = itm.substring(18, itm.length)
    //             newstr2 = strJson2.split("')")[0]
    //             let json = JSON.parse(strJson.replace(/'/g,'"'));
    //             json.headerId = newstr2
               
    //             dataTmp.push(json)
               
    //         })    
            
    //         this.fetchS3Objects(dataTmp)
    //     })
    //     .catch(error =>{
    //         alert("error: imagecheck list " + error +" getprofileImage11")
    //     })
    // };

    fetchS3Objects = (dataTmp) => {
        //console.log("fetchS3Objects dataTmp:");
        //console.log(dataTmp[0].newId);
        const newId = dataTmp[0].newId; 

        return new Promise((resolve, reject) => {
            AWS.config.update({
                 
                accessKeyId: AppConfiguration.Setting().accessKeyId,
                secretAccessKey: AppConfiguration.Setting().secretAccessKey, 
                region: 'us-east-1'
            });
            const s3 = new AWS.S3();
            const params = {
                Bucket: 'job-space-resume-pics-noser-cdr',
            };

            s3.listObjectsV2(params, (err, data) => {
                if (err) {
                    //console.log("Error fetching objects from S3: ", err);
                    reject(err);
                } else {
                    //console.log("Candidate tagging newId: ", newId);
                    // //console.log("Fetched objects: ", data.Contents);
                    const s3objects = data.Contents;
                    //console.log("s3objects");
                    //console.log(s3objects);
                    // s3objects.forEach(object => {
                    //     const key = object.Key
                    //     //console.log(key)
                    // })
                    let matchFound = false; 
                    //console.log("Start finding candidate resume picture ...");
                    for (const object of s3objects) {
                        const key = object.Key;
                        // //console.log("Key: ", key);
                        
                        const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
                        // //console.log("Key without extension: ", keyWithoutExtension);
    
                        const last14Digits = keyWithoutExtension.slice(-14);
                        // //console.log("Last 14 digits: ", last14Digits);
    
                        if (last14Digits === newId) {
                            // //console.log("Match found for newId: ", newId);
                            //console.log("Candidate Resume Picture found: ", key);
                            
                            matchFound = true;
                            this.viewS3Object(key);

                            break;
                        }
                    }
    
                    if (!matchFound) {
                        //console.log("No match found for newId: ", newId);
                    }

                    resolve(data.Contents);
                }
            });
        });
    };

    viewS3Object = (objectKey) => {
        
        const baseUrl = "https://job-space-resume-pics-noser-cdr.s3.us-east-1.amazonaws.com/";
        
        const fullUrl = `${baseUrl}${objectKey}`;
        
        //console.log("Fetching image full URL: ", fullUrl); 
        //console.log("Start redering picture...");
    
        const fileType = objectKey.split('.').pop().toLowerCase();
    
        if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
            
            this.setState({
                newImage: fullUrl,
                newImageShow: true,
                photoLabel: false,
            }); 
            //console.log("Image rendered!");
        } else {
            console.error("Unsupported file type for rendering:", fileType);
        }
    };

    fetchDocumentFromS3 = (dataTmp) => {
        const newId = dataTmp[0].newId;
    
        return new Promise((resolve, reject) => {
            AWS.config.update({
               
                accessKeyId: AppConfiguration.Setting().accessKeyId,
                secretAccessKey: AppConfiguration.Setting().secretAccessKey, 
                region: 'us-east-1'
            });
            const s3 = new AWS.S3();
            const params = {
                Bucket: 'job-space-bucket-noser-cdr',
            };
    
            s3.listObjectsV2(params, (err, data) => {
                if (err) {
                    //console.log("Error fetching documents from S3: ", err);
                    reject(err);
                } else {
                    //console.log("newId: ", newId);
                    const s3objects = data.Contents;
                    //console.log("s3objects");
                    //console.log(s3objects);
    
                    let matchFound = false;
    
                    for (const object of s3objects) {
                        const key = object.Key;
                        // //console.log("Key: ", key);
    
                        const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
                        // //console.log("Key without extension: ", keyWithoutExtension);
    
                        const last14Digits = keyWithoutExtension.slice(-14);
                        // //console.log("Last 14 digits: ", last14Digits);
    
                        if (last14Digits === newId) {
                            //console.log("Match found for newId: ", newId);
                            //console.log("Matched Original Document Key: ", key);

                            // const keyWithoutLast14Digits = key.replace(/-\d{14}$/, '');
                            // const keyWithoutLast14Digits = key.substring(0, key.length - 15);
                            const keyWithoutLast14Digits = key.replace(/-\d{14}(\.\w+)$/, '$1');
                            //console.log("Match found for newId: ", newId);
                            //console.log("Matched Document Key keyWithoutLast14Digits : ", keyWithoutLast14Digits);

                            matchFound = true;
                            
                            this.handleMatchedDocument(key);
                            // this.handleMatchedDocument(keyWithoutLast14Digits);
                            
                            break; 
                        }
                    }
    
                    if (!matchFound) {
                        //console.log("No match found for newId: ", newId);
                    }
    
                    resolve(data.Contents);
                }
            });
        });
    };

    handleMatchedDocument = (objectKey) => {
        const baseUrl = "https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/";
        const fullUrl = `${baseUrl}${objectKey}`;
        
        //console.log("Matched Document URL: ", fullUrl);
        
        const originalDocumentName = objectKey.split('/').pop();
        //console.log("Original Document Name:", originalDocumentName);
        
        const matchedDocumentName = originalDocumentName.replace(/-\d{14}\.pdf$/, '.pdf');
        //console.log("Formatted Document Name:", matchedDocumentName);
        
        this.setState({
            matchedDocumentUrl: fullUrl,
            matchedDocumentName: matchedDocumentName,
            matchedDocumentKey: objectKey
        });
    };

    //------------------------------ ADDED BY NEL ENDS HERE ------------------------------//


    checklistcandi=async(clientId)=>{
        //console.log("checklistcandi")
        let filter_data = {
            "isDeleted" : "0", 
            "userId" : this.state.userinfo.userid,
            //"isDeleted" : "0",
           /*  "firstName" : firstName,
            "lastName"  : lastName, */
        };

        const Params = {
            "_collection" : "CandidateRegisteredCheckList",
            "filter_data" : filter_data
        }

        await axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {
            //console.log("get data CandidateRegisteredCheckList ")
            //console.log("res.data")
            //console.log(res)
     
            let dataTmp = []
            let a
            let dataaa = res.data
            //console.log("data")
            //console.log(dataaa)
            let newstr2=""
            dataaa.CandidateRegisteredCheckList.map(function(itm,i){
              let strJson = "{" + itm.substring(46, itm.length)
              let strJson2 = itm.substring(18, itm.length)
              newstr2 = strJson2.split("')")[0]
              let json = JSON.parse(strJson.replace(/'/g,'"'));
              json.headerId = newstr2
              //console.log(json.headerId)
              //setheaderId(json.headerId)
              dataTmp.push(json)
              a = json
            })    
           // setheaderId(dataTmp[0].h)
            //updateCompanyRegisteredCheckList()
            //console.log("CandidateRegisteredCheckList gewt dataTmp")
            //console.log(dataTmp)
            dataTmp.forEach(element => {
                element.basicInfoCandidate ="1"
            });
            
            if(res.status === 200){
                this.updateCandidateChecklist(a,dataTmp,clientId)
            }
        })
        .catch(error =>{
            //console.log("2")
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
            return
        })
    }

    updateCandidateChecklist=(a,dataTmp,clientId)=>{
        //console.log("updateCandidateChecklist")
      
        ////console.log(dataTmp[0])

        let d = new Date();
        let createddate = moment(d).format('MM/DD/YYYY');
        let w = d.toLocaleTimeString()
        //User for Client ID
        let today = new Date()
        //let clientId = moment(today).format('MMYYYYhhmmss');
        let obj = {
            "userId"                : this.state.userinfo.userid,
            "employerId"            : clientId,
            "education"             : a.education, 
            "basicInfoCandidate"    : "1",
            "workExperience"        : a.workExperience,
            "isDeleted"             : "0",
            "createdDate"             :a.createdDate,
            "timestamp"               : a.timestamp,
            "isDraft"                 : "0",
            "isModifiedDate"          : w
        }

        const updateParams = {

            "_collection" : "CandidateRegisteredCheckList",
            "doc_data"    : obj,
            "_id"         :a.headerId,
  
        }

        //console.log(" toUpdate")
        //console.log(updateParams)
  
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/update_one", updateParams)
        .then(res => {
            let data = res.data
            //console.log(data)
            //console.log(res.status)
            if(res.status === 200){
                this.handleGetCompanyChecklist2()
            }
       
       
        }).catch(error =>{
            //console.log("3")
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
            return
        })
    }

    handleGetCompanyChecklist2 = async() => {
        //console.log("CandidateRegisteredCheckList")
        let filter_data = {
          "isDeleted" : "0", 
          "userId" : this.state.userinfo.userid,
          //"isDeleted" : "0",
         /*  "firstName" : firstName,
          "lastName"  : lastName, */
        }
        
        const Params = {
          "_collection" : "CandidateRegisteredCheckList",
          "filter_data" : filter_data
        }
       
         axios
         .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            //console.log("res.data get number 2")
            //console.log(res)
    
            let dataTmp = []
            let a
            let dataaa = res.data
            //console.log("data")
            //console.log(dataaa)
            let newstr2=""
            dataaa.CandidateRegisteredCheckList.map(function(itm,i){
              let strJson = "{" + itm.substring(46, itm.length)
              let strJson2 = itm.substring(18, itm.length)
              newstr2 = strJson2.split("')")[0]
              let json = JSON.parse(strJson.replace(/'/g,'"'));
              json.headerId = newstr2
              //console.log(json.headerId)
              //setheaderId(json.headerId)
              dataTmp.push(json)
              //a = json
            })    
           // setheaderId(dataTmp[0].h)
            //updateCompanyRegisteredCheckList()
            //console.log("dataTmp")
            //console.log(dataTmp)
            /* dataTmp.forEach(element => {
                element.basicInfoCompany ="1"
            });*/
            if(res.status === 200){
                //naviga("/")
                //this.uploadFile()
               // this.setState({navigate : true})
            } 
           
            //sessionStorage.setItem("CompanyProfile", JSON.stringify(dataTmp))
        })
        .catch(error =>{
            //console.log("4")
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
            return
        })
    };

   

    

    handleNickNameDoubleSpaces = (e) =>{
        var theEvent = e || window.event;
        //var key = theEvent.keyCode || theEvent.which;
        if(this.state.nickNamekeycode === "" && e.which === 32){
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }

        if(this.state.nickNamekeycode === 32 && e.which === 32){
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
        this.state.nickNamekeycode = e.which
    }
    handleFirstNameDoubleSpaces = (e) =>{
        var theEvent = e || window.event;
        //var key = theEvent.keyCode || theEvent.which;
        if(this.state.firstNamekeycode === "" && e.which === 32){
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }

        if(this.state.firstNamekeycode === 32 && e.which === 32){
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
        this.state.firstNamekeycode = e.which
    }
    handleMiddleNameDoubleSpaces = (e) =>{
        var theEvent = e || window.event;
        //var key = theEvent.keyCode || theEvent.which;
        if(this.state.middleNamekeycode === "" && e.which === 32){
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }

        if(this.state.middleNamekeycode === 32 && e.which === 32){
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
        this.state.middleNamekeycode = e.which
    }
    handleLastNameDoubleSpaces = (e) =>{
        var theEvent = e || window.event;
        //var key = theEvent.keyCode || theEvent.which;
        if(this.state.lastNamekeycode === "" && e.which === 32){
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }

        if(this.state.lastNamekeycode === 32 && e.which === 32){
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
        this.state.lastNamekeycode = e.which
    };

    // fileChangedHandler(event) {

    //     const selectedFile = event.target.files[0];
    //     //console.log("Selected file:", selectedFile);

    //     // Update the state with the selected file
    //     //this.setState({ file: selectedFile });
        
    //     var fileInput = false;
    //     if (event.target.files[0]) {
    //       fileInput = true;
    //     }
    //     if (fileInput) {
    //       try {
    //         this.setState({fileImage: event.target.files[0]});
    //         Resizer.imageFileResizer(
    //           event.target.files[0],
    //           1,
    //           200,
    //           "JPEG",
    //           100,
    //           0,
    //           (uri) => {
    //             ////console.log(uri);
    //             this.setState({ file: selectedFile });
    //             this.setState({ newImage: uri, newImageShow:true, photoLabel:false });
    //           },
    //           "base64",
    //           200,
    //           200
    //         );
    //       } catch (err) {
    //         ////console.log(err);
    //       }
    //     }
    // };

    fileChangedHandler = (event) => {
        const selectedFile = event.target.files[0];
        //console.log("Selected file:", selectedFile);

        if (selectedFile) {
            this.setState({ fileImage: selectedFile });
            Resizer.imageFileResizer(
                selectedFile,
                1,
                200,
                "JPEG",
                100,
                0,
                (uri) => {
                    if (this.fileInputRef.current) {
                        // this.fileInputRef.current.value = "";
                        this.fileInputRef = null;
                    }
                    this.setState({ newImage: uri, newImageShow: true, photoLabel: false });
                },
                "base64",
                200,
                200
            );
        }
    };

    handleUpload = () => {
        if (this.fileInputRef.current) {
            //console.log("File input ref is valid");
            
        } else {
            console.error("File input ref is null");
        }
    };

    //w function application history
    onChangewsd = date => {
        ////console.log("newStartDate")
        ////console.log(date)
       this.setState({wstartdate : date})
        // thi
        // setStartDate(newStartDate);
        // setEndDate(newEndDate);
    };
    wenddate = date => {
        ////console.log("newendDate")
        ////console.log(date)
        this.setState({wstartdate : date})
       
        // thi
        // setStartDate(newStartDate);
        // setEndDate(newEndDate);
    };
    handleChangeClientAH=(e)=>{
        if(e.length == 0) {
            this.state.clientIdAH     =   ""
            this.state.clientIdAH   =   ""
            return
        }
        this.state.clientIdAH     =   e[0].id
        this.state.clientNameAH   =   e[0].name
    };
    handleChangePositionAH = (e) => {
        if(e.length == 0) {
            this.state.positionIdAH     =   ""
            this.state.positionNameAH   =   ""
            return
        }
        this.state.positionIdAH     =   e[0].id
        this.state.positionNameAH   =   e[0].name
    };
    onChangeRefNoAF = (e) => {
        this.setState({ refNoAF: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });
    };
    handleChangeDateAppliedAF = date => {
        this.setState({dateAppliedAF: date,isshow:false,})
    };
    onChangeRemarks = (e) => {
        this.setState({ remarksAF: e.target.value.replace(/[^\w\s]/gi, ""),isshow:false });  
    };
    handleAddApplicationHistory = (e) =>{
        let a = this.state.applicationHistoryGrid
        let today = new Date()
        let newId = moment(today).format('HHMMSS');
        let b = moment(this.state.dateAppliedAF).format("MM/DD/YYYY");
        const obj = {
            "id"            :   newId.toString(),
            "clientName"    :   this.state.clientNameAH,
            "positionAF"      :   this.state.positionNameAH,
            "referenceNo"   :   this.state.refNoAF,
            "dateApplied"   :   this.state.dateAppliedAF,
            "formatedDate" : b,
            "remarks"       :   this.state.remarksAF,
            "isModified"    :   "0",
            "isDeleted"     :   "0",  
        };
        a.push(obj) 
        ////console.log(a)
        this.setState({
            applicationHistoryGrid : a,  
            isshow:false,
            clientNameAH : "",
            positionNameAH : "",
            refNoAF:"",
            dateAppliedAF:"",
            remarksAF : "",
        })

    };

    handleRemoveApplicationHistory = (e) =>{
        let applicationHistoryGrid = this.state.applicationHistoryGrid.filter(x=>x.isDeleted=="0")
        this.state.employmentRecordGrid = []
        this.setState({applicationHistoryGrid:applicationHistoryGrid,disableRemoveEmploymentRecord: applicationHistoryGrid.length===0 ? true : false})
    };

    // fileUploadChangedHandler=(event)=>{
    //     //console.log(event.target.files[0])
    //     var fileInput = false;
    //     if (event.target.files[0]) {
    //       fileInput = true;
    //     }

    //     ////console.log("event.target.files[0]")
    //     ////console.log(event.target.files[0])


        
    //     this.setState({ uploadResume : event.target.files[0]})
    // }

    fileUploadChangedHandler = (event) => {
        const selectedFile = event.target.files[0];
        //console.log("Selected file for resume:", selectedFile);
        if (selectedFile) {
            this.setState({ uploadResume: selectedFile });
        } else {
            alert("No file selected for upload.");
        }
    };

    //w function application history
    
    //w grid function 
    /* autofillEducation=(i)=>{
        let a = this.state.educationGrid
        let b = this.state.levelDDLtwo
        
        b.forEach(element => {
           //element.id = (tmp+1).toString()
            element.SchoolName = this.state.SchoolName
            element.Course        =   this.state.Course
            element.StartYear     =   this.state.StartYear
            element.EndYear       =   this.state.EndYear
            element.HonorRecieved =   this.state.honorsAward
            element.contactPerson =   ""
            element.contactNumber =   ""
        });

        
        //console.log("autofillEducation")
        //console.log(a)
        this.setState({educationGrid : b }) 
        this.autofillFamilyBackground()
    }; */
    autofillFamilyBackground=()=>{
        let a = this.state.familyBackgroundGrid
        let b = this.state.roleDDLtwo
        let newId = moment(new Date()).format('HHMMSS');
        b.forEach((itm,idx) => {
            itm.id = (newId + (idx+1)).toString()
            itm.name = this.state.fbName
            itm.contactNumber = this.state.fbCNumber
            itm.age = this.state.fbAge
            itm.occupation = this.state.fbOccupation
            itm.company = this.state.fbCOSchool
            itm.userId = this.state.userinfo.userid
            itm.role = this.state.role
            itm.isDeleted = "0"
         })
         ////console.log("asdasdasd")
         ////console.log(b)
         
         this.setState({familyBackgroundGrid : b }) 
    }
    //w grid function 
    handleValidate = async()=>{
        this.setState({alerttype:'',isshow:false,color:'',message:'',fade:true,isloading:true})
        const param ={
            "IpAddress"                 : "0.0.0.0",
            "ClientId"                  : this.state.clientId,
            "UserId"                    : this.state.userinfo.userid,
            "FirstName"                 : this.state.fName,
            "NickName"                  : this.state.nName,
            "MiddleName"                : this.state.mName,
            "LastName"                  : this.state.lName,
            "DateOfBirth"               : this.FormatDate(this.state.dateOfBirth),
            "TINNumber"                 : this.state.tin,
            "SSSNumber"                 : this.state.sss,
            "PHICNumber"                : this.state.phic,
            "HDMFNumber"                : this.state.pagibig,
        }

        await axios
            .post(
                AppConfiguration.Setting().hrisapi + "Recruitment/ValidateApplicant",  param
            )
            .then(res => {
                const data = res.data;
                this.setState({
                    isloading   :   false,
                    alerttype   :   res.data.status=="1" ? "Success!" : "!Error",
                    isshow      :   true,
                    color       :   res.data.status=="1" ? "success" : "danger",
                    message     :   data.message,
                    fade        :   true,
                    name        :   ''
                });
            })
            .catch(error=>{
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Error!",
                    isshow      :   true,
                    color       :   "danger",
                    message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                    fade        :   true,
                    name        :   ''
                })
            })
    }
    IsValidMobile(val){
        var regex = /^0(9|4)\d{9}$/;
        return !regex.test(val)
    }
    ValidateMobileNumber = (e) =>{
        this.setState({isloading:true})
        if(this.IsValidMobile(e.target.value.replace(/[^\w\s]/gi, ""))){
            alert(e.target.name==="mobileNumber" ? "Mobile number should start with 09 followed by 9 digits." : "Emergency contact number should start with 09 followed by 9 digits.")
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: e.target.name==="mobileNumber" ? "Mobile number should start with 09 followed by 9 digits." : "Emergency contact number should start with 09 followed by 9 digits.",
                fade:true
            });
            return
        }
        this.setState({isloading:false})
    }
    render() {
         const { navigate } = this.state;
         const { showModal } = this.state;

         const { s3Objects, searchQuery, selectedFileContent, name, company, showAlert, alertMessage } = this.state;

         /* const filteredS3Objects = this.state.s3Objects.filter(object =>
             object.Key.toLowerCase().includes(this.state.searchQuery.toLowerCase())
         );
 */
        // //const { SearchBar } = Search;
        if (navigate) {
            return <Navigate to="/ApplicationFormView" push={true} />;
        } 



        
       /*  const { navigateBack}= this.state;
        if (navigateBack) {
            return <Navigate to="/ApplicationFormView" push={true} />;
        }  */

        const educationColumn = [
            {
                dataField: 'LevelId',
                text: 'Level',
                headerStyle: () => {
                    return { width: "14%" };
                },
                formatter: (cell, row) => {
                    if(row.LevelId!='' && row.LevelId!=null){
                        if(this.state.tblLevelArrLst.filter(x => x.value == cell).length==0)
                             return ""
                        else
                         return this.state.tblLevelArrLst.find(x => x.value == cell).label;
                    }
                },
                editor: {
                    type: Type.SELECT,
                    options: this.state.tblLevelArrLst
                },
                validator: (newValue, row, column) => {
                    if(this.state.educationGrid.filter(x=>x.LevelId===newValue).length>0)
                    return {
                        valid: false,
                        message:"Selected level already exist."
                      };
                    return true;   
                }
            },
            {
                dataField: 'SchoolName',
                text: 'School Name',
                ediatable : false,
                headerStyle: () => {
                    return { width: "28%" };
                  },
                  validator: (newValue, row, column) => {
                      if(row.LevelId==="")
                      return {
                          valid: false,
                          message:"Please select school level."
                        };
                      return true;   
                  }
            },
            {
                dataField: 'Course',
                text: 'Course',
                headerStyle: () => {
                    return { width: "19%" };
                  },
                  validator: (newValue, row, column) => {
                      if(row.SchoolName==="")
                      return {
                          valid: false,
                          message:"Please enter school name."
                        };
                      return true;   
                  }
            },
            {
                dataField: 'StartYear',
                text: 'Start Year',
                headerStyle: () => {
                    return { width: "9%" };
                },
                validator: (newValue, row, column) => {
                    this.setState({
                        totalValue : newValue
                    })
                    if(row.Course==="")
                        return {
                            valid: false,
                            message:"Please enter Course."
                    };
                    if (this.ValidNumeric(newValue)) {
                    return {
                        valid: false,
                        message:"Value must be numeric."
                    };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'EndYear',
                text: 'End Year',
                headerStyle: () => {
                    return { width: "9%" };
                  },
                  validator: (newValue, row, column) => {
                      if(row.StartYear==="")
                          return {
                          valid: false,
                          message:"Please enter start year."
                      };
                      if (this.ValidNumeric(newValue)) {
                        return {
                          valid: false,
                          message:"Value must be numeric."
                        };
                      } 
                      return true;   
                  }
            },
            {
                dataField: 'HonorRecieved',
                text: 'Honor Recieved',
                headerStyle: () => {
                    return { width: "21%" };
                },
                validator: (newValue, row, column) => {
                    if(row.EndYear==="")
                        return {
                        valid: false,
                        message:"Please enter start year."
                    };
                    return true;   
                }
            },
            // {
            //     dataField: 'action',
            //     text: 'ACTION',
            //     editable:false,
            //     headerStyle: (colum, colIndex) => {
            //         return { textAlign: 'center',width:'7%'}
            //     },
            //     style:{textAlign:'center',width:'7%'},
            //     formatter   :   (cell, row, isSelect) => {
            //         return (
            //             <Button 
            //                 onClick={e => this.handleRemoveEducation(row.id)}
            //                 style={{height:'18px',paddingTop:'0',marginTop:'-4px',fontSize:'11px'}} 
            //                 variant="link"
            //         >REMOVE</Button>
            //         );
            //     },
            // }
        ]

        const educationSelectRow = {
            mode: '',
            hideSelectAll: true,
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                
            }
        };

        const employmentRecordColumn = [
            {
                dataField: 'CompanyName',
                text: 'Company Name',
                headerStyle: () => {
                    return { width: "20%" };
                }
                
            },
            {
                dataField: 'CompanyAddress',
                text: 'Company Address',
                headerStyle: () => {
                    return { width: "20%" };
                }
            },
            {
                dataField: 'Position',
                text: 'Position',
                headerStyle: () => {
                    return { width: "20%" };
                }
            },
            /* {
                dataField: 'periodCovered',
                text: 'Period_Covered',
                headerStyle: () => {
                    return { width: "20%" };
                }
            }, */
            {
                dataField: 'FromStart',
                text: 'From Start',
                headerStyle: () => {
                    return { width: "10%" };
                }
            },
            {
                dataField: 'ToEnd',
                text: 'To End',
                headerStyle: () => {
                    return { width: "10%" };
                }
            },
            {
                dataField: 'ReasonForLeaving',
                text: 'Reason For Leaving',
                headerStyle: () => {
                    return { width: "25%" };
                }
            },
            {
                dataField: 'Salary',
                text: 'Salary',
                headerStyle: () => {
                    return { width: "20%" };
                },
                style:{textAlign:'right',whiteSpace:'nowrap'}
            },
        ]

        const employmentRecordSelectRow = {
            mode: 'checkbox',
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                let isDisable = true
                this.state.employmentRecordGrid.map(function(item,i){
                    if(item.id===row.id)
                        item.isDeleted = isSelect ? "1" : "0"
                    if(item.isDeleted=="1")
                        isDisable=false
                })
                this.setState({disableRemoveEmploymentRecord:isDisable})
            },
            onSelectAll: (isSelect, rows) => {
                let isDisable = true
                this.state.employmentRecordGrid.map(function(itm){
                    itm.isDeleted=isSelect ? "1" : "0"
                    if(itm.isDeleted=="1")
                        isDisable=false
                })
                this.setState({disableRemoveEmploymentRecord:isDisable})
            }
        };

        // const applicationHistorySelectRow = {
        //     mode: 'checkbox',
        //     clickToSelectAndEditCell: true,
        //     onSelect: (row, isSelect, rowIndex, e) => {
        //         let isDisable = true
        //         this.state.applicationHistoryGrid.map(function(item,i){
        //             if(item.id===row.id)
        //                 item.isDeleted = isSelect ? "1" : "0"
        //             if(item.isDeleted=="1")
        //                 isDisable=false
        //         })
        //         this.setState({disableRemoveEmploymentRecord:isDisable})
        //     },
        //     onSelectAll: (isSelect, rows) => {
        //         let isDisable = true
        //         this.state.applicationHistoryGrid.map(function(itm){
        //             itm.isDeleted=isSelect ? "1" : "0"
        //             if(itm.isDeleted=="1")
        //                 isDisable=false
        //         })
        //         this.setState({disableRemoveEmploymentRecord:isDisable})
        //     }
        // };

        

        const familyBackgroundColumn = [
            {
                dataField: 'RoleId',
                text: 'Role',
                headerStyle: () => {
                    return { width: "15%" };
                },
                formatter: (cell, row) => {
                    if(row.RoleId!='' && row.RoleId!=null){
                        return this.state.tblRoleArrLst.find(x => x.value == cell).label;
                    }
                },
                editor: {
                    type: Type.SELECT,
                    options: this.state.tblRoleArrLst.filter(x=>x.value)
                },
                /* validator: (newValue, row, column) => {
                    
                    if(this.state.familyBackgroundGrid.filter(x=>x.RoleId===newValue).length>0 && newValue==="0")
                    return {
                        valid: false,
                        message:"Cannot set multiple for role father."
                      };
                    if(this.state.familyBackgroundGrid.filter(x=>x.RoleId===newValue).length>0 && newValue==="1")
                    return {
                        valid: false,
                        message:"Cannot set multiple for role mother."
                    };
                    if(this.state.familyBackgroundGrid.filter(x=>x.RoleId===newValue).length>0 && newValue==="2")
                    return {
                        valid: false,
                        message:"Cannot set multiple for role spouse."
                    };
                    return true;   
                } */
            },
            {
                dataField: 'Name',
                text: 'Name',
                headerStyle: () => {
                    return { width: "20%" };
                },
                editCellStyle: {
                  fontWeight: 'bold'
                }
            },
            {
                dataField: 'ContactNumber',
                text: 'Contact Number',
                headerStyle: () => {
                    return { width: "15%" };
                },
                validator: (newValue, row, column) => {
                    if(this.IsValidMobile(newValue))
                    return {
                        valid: false,
                        message:'Contact number should start with 09 followed by 9 digits.'
                      };
                    return true;
                },
            },
            {
                dataField: 'Age',
                text: 'Age',
                headerStyle: () => {
                    return { width: "10%" };
                    }
            },
            {
                dataField: 'Occupation',
                text: 'Occupation',
                headerStyle: () => {
                    return { width: "20%" };
                }
            },
            {
                dataField: 'Company',
                text: 'Company',
                headerStyle: () => {
                    return { width: "20%" };
                }
            },
        ]

        const familyBackgroundSelectRow = {
            mode: 'checkbox',
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                let isDisable = true
                this.state.familyBackgroundGrid.map(function(item,i){
                    if(item.id===row.id)
                        item.isDeleted = isSelect ? "1" : "0"
                    if(item.isDeleted=="1")
                        isDisable=false
                })
                this.setState({disableBackground:isDisable})
            },
            onSelectAll: (isSelect, rows) => {
                let isDisable = true
                this.state.familyBackgroundGrid.map(function(itm){
                    itm.isDeleted=isSelect ? "1" : "0"
                    if(itm.isDeleted=="1")
                        isDisable=false
                })
                this.setState({disableBackground:isDisable})
            }
        };

        // const othersColumn = [
        //     {
        //         dataField: 'jobSourceId',
        //         text: 'Job Opening',
        //         headerStyle: () => {
        //             return { width: "10%" };
        //         },
        //         formatter: (cell, row) => {
        //             if(row.jobSourceId!='' && row.jobSourceId!=null){
        //                 return this.state.tblJobOpeningArrLst.find(x => x.value == cell).label;
        //             }
        //         },
        //         /* editor: {
        //             type: Type.SELECT,
        //             options: this.state.tblJobOpeningArrLst
        //         } */
        //         /* headerStyle: () => {
        //             return { width: "10%" };
        //         },
        //         formatter: (cell, row) => {
        //             if(row.RoleId!='' && row.RoleId!=null){
        //                 return this.state.tblRoleArrLst.find(x => x.value == cell).label;
        //             }
        //         },
        //         editor: {
        //             type: Type.SELECT,
        //             options: this.state.tblRoleArrLst
        //         } */
        //     },
        //     {
        //         dataField: 'refferedBy',
        //         text: 'Preffered By',
        //         headerStyle: () => {
        //             return { width: "15%" };
        //             }
        //     },
        //     /* {
        //         dataField: 'presentlyConnected',
        //         text: 'Presently Connected',
        //         headerStyle: () => {
        //             return { width: "5%" };
        //             }
        //     }, */
        //     {
        //         dataField: 'relativeName',
        //         text: 'Name',
        //         headerStyle: () => {
        //             return { width: "15%" };
        //             }
        //     },
        //     {
        //         dataField: 'relativeRelation',
        //         text: 'Relationship',
        //         headerStyle: () => {
        //             return { width: "10%" };
        //             }
        //     },
        //     {
        //         dataField: 'relativePosition',
        //         text: 'Job Title',
        //         headerStyle: () => {
        //             return { width: "10%" };
        //             }
        //     },
        //     {
        //         dataField: 'contactNumber',
        //         text: 'Contact Number',
        //         headerStyle: () => {
        //             return { width: "10%" };
        //             }
        //     },
        //     /* {
        //         dataField: 'convictedWithACrime',
        //         text: 'Convicted With A Crime',
        //         headerStyle: () => {
        //             return { width: "5%" };
        //             }
        //     }, */
        //     {
        //         dataField: 'crimeDescription',
        //         text: 'Give Details Crime',
        //         headerStyle: () => {
        //             return { width: "10%" };
        //             }
        //     },
        //     /* {
        //         dataField: 'labourUnion',
        //         text: 'Member Of A Labour Union',
        //         headerStyle: () => {
        //             return { width: "5%" };
        //             }
        //     }, */
        //     {
        //         dataField: 'laborUnionDescription',
        //         text: 'Give Details Union',
        //         headerStyle: () => {
        //             return { width: "10%" };
        //             }
        //     },
        //     {
        //         dataField: 'diagnoseDeseaseId',
        //         text: 'Suffered or Diagnosed',
        //         headerStyle: () => {
        //             return { width: "10%" };
        //         },
        //         formatter: (cell, row) => {
        //             if(row.diagnoseDeseaseId!='' && row.diagnoseDeseaseId!=null){
        //                 return this.state.tblDiseaseArrLst.find(x => x.value == cell).label;
        //             }
        //         },
        //        /*  editor: {
        //             type: Type.SELECT,
        //             options: this.state.tblDiseaseArrLst
        //         } */
        //     },
        // ]

        // const othersSelectRow = {
        //     mode: 'checkbox',
        //     clickToSelectAndEditCell: true,
        //     onSelect: (row, isSelect, rowIndex, e) => {
        //         let isDisable = true
        //         this.state.othersGrid.map(function(item,i){
        //             if(item.id===row.id)
        //                 item.isDeleted = isSelect ? "1" : "0"
        //             if(item.isDeleted=="1")
        //                 isDisable=false
        //         })
        //         this.setState({disableOthers:isDisable})
        //     },
        //     onSelectAll: (isSelect, rows) => {
        //         let isDisable = true
        //         this.state.othersGrid.map(function(itm){
        //             itm.isDeleted=isSelect ? "1" : "0"
        //             if(itm.isDeleted=="1")
        //                 isDisable=false
        //         })
        //         this.setState({disableOthers:isDisable})
        //     }
        // };

        const referenceColumn = [
            {
                dataField: 'TypeId',
                text: 'Type of Character Reference',
                headerStyle: () => {
                    return { width: "15%" };
                },
                formatter: (cell, row) => {
                    if(row.TypeId!='' && row.TypeId!=null){
                        return this.state.tbltypeofcharacterreferenceArrLst.find(x => x.value == cell).label;
                    }
                },
                editor: {
                    type: Type.SELECT,
                    options: this.state.tbltypeofcharacterreferenceArrLst
                }
            },
            {
                dataField: 'Name',
                text: 'Name',
                headerStyle: () => {
                    return { width: "25%" };
                  }
            },
            {
                dataField: 'ContactNumber',
                text: 'Contact Number',
                headerStyle: () => {
                    return { width: "20%" };
                  },
                validator: (newValue, row, column) => {
                    if(this.IsValidMobile(newValue))
                    return {
                        valid: false,
                        message:'Contact number should start with 09 followed by 9 digits.'
                      };
                    return true;
                },
            },
            {
                dataField: 'Occupation',
                text: 'Occupation',
                headerStyle: () => {
                    return { width: "25%" };
                  }
            },
            {
                dataField: 'Company',
                text: 'Company',
                headerStyle: () => {
                    return { width: "30%" };
                  }
            },
        ]

        const referenceSelectRow = {
            mode: 'checkbox',
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                let isDisable = true
                this.state.referenceGrid.map(function(item,i){
                    if(item.id===row.id)
                        item.isDeleted = isSelect ? "1" : "0"
                    if(item.isDeleted=="1")
                        isDisable=false
                })
                this.setState({disableReference:isDisable})
            },
            onSelectAll: (isSelect, rows) => {
                let isDisable = true
                this.state.referenceGrid.map(function(itm){
                    itm.isDeleted=isSelect ? "1" : "0"
                    if(itm.isDeleted=="1")
                        isDisable=false
                })
                this.setState({disableReference:isDisable})
            }
        };

        // const APPLICATIONHISTORYColumn = [
        //     {
        //         dataField: 'clientName',
        //         text: 'Client Name',
        //         headerStyle: () => {
        //             return { width: "25%" };
        //         }
                
        //     },
        //     {
        //         dataField: 'positionAF',
        //         text: 'Position',
        //         headerStyle: () => {
        //             return { width: "25%" };
        //         }
        //     },
        //     {
        //         dataField: 'referenceNo',
        //         text: 'reference No',
        //         headerStyle: () => {
        //             return { width: "25%" };
        //         }
        //     },
        //     {
        //         dataField: 'formatedDate',
        //         text: 'date Applied',
        //         headerStyle: () => {
        //             return { width: "25%" };
        //         },
                
        //     },
            
        // ]


        return(
            <div>
            {/* <Banner /> */}
                <Container  className="mt-3 " fluid={true}>
                    <Row className='mt-5'></Row>
                    <Row className='mt-5'></Row>
                    <Row className='mt-3'></Row>
                    <Row className='mt-5'></Row>
                    
                    <Card style={{borderColor : 'grey'}} className="appFormBackground1">
                        <Card.Header style={{backgroundColor : "green",color : 'white'}}>CANDIDATE PROFILE (EDIT/UPDATE)</Card.Header>
                        <Card.Body className="appFormBackground1">
                            <Form>
                                <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                                    <div className={this.state.color}></div> 
                                    {this.state.message}
                                </Alert>
                                {/* <Row>
                                    <Form.Group as={Col} controlId="formGridAddress1">
                                        <Form.Label style={{fontWeight : "bold"}}>CLIENT</Form.Label>
                                        <Typeahead 
                                            ref='clientref'
                                            labelKey='name'
                                            id="basic-example"
                                            onChange={this.handleChangeClient}
                                            options={this.state.clientDDL}
                                            placeholder="Select Client" 
                                        />
                                    </Form.Group>
                                </Row>
                                <Row className="mt-2">
                                    <Form.Group as={Col} controlId="formGridCity">
                                        <Form.Label style={{fontWeight : "bold"}}>POSITION APPLIED</Form.Label>
                                        <Typeahead
                                            ref='positionref'
                                            labelKey='name'
                                            id="basic-example"
                                            onChange={this.handleChangePosition}
                                            options={this.state.positionDDL}
                                            placeholder="Select Position" 
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formGridAddress1">
                                        <Form.Label style={{fontWeight : "bold", marginLeft : 15}}>DATE APPLIED</Form.Label>
                                        <Form.Group as={Col} controlId="formGridCity">
                                        <DatePicker
                                            ref='dateApplied'
                                            selected={this.state.dateApplied}
                                            onChange={this.handleChangeDateApplied}
                                            minDate={this.minDate}
                                            value={this.props.dateApplied}
                                            dateFormat={"MM/dd/yyyy"}
                                            className="form-control"
                                            wrapperClassName="datepicker"
                                            placeholderText="Select Date Applied" 
                                        />
                                        </Form.Group>
                                    </Form.Group>
                                </Row> */}
                                <Tabs style={{borderColor : 'grey'}} className="mt-2 tabColor" defaultActiveKey="default" transition={false} id="noanim-tab-example">
                                    <Tab className='tabColor' eventKey="default" title="I. GENERAL INFORMATION">
                                        <Card className="card-tab-no-border">
                                            <Card.Body className="appFormBackground1">
                                                
                                                <Row>
                                                    <Form.Group as={Col} controlId="formGridAddress1">
                                                        <Form.Label style={{fontWeight : "bold"}}></Form.Label>
{/*                                                             <Form.Control
                                                            as="select"
                                                            onChange={this.handleChangeTitle}
                                                            value={this.state.titleValue}
                                                        >
                                                        {this.state.titleDDL.map(item => (
                                                            <option key={item.value} value={item.value}>
                                                            {item.name}
                                                            </option>
                                                        ))}
                                                        </Form.Control> */}
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        {/* <input 
                                                            type="file" 
                                                            name='file' 
                                                            required 
                                                            onChange={this.fileChangedHandler} 

                                                            ref={this.fileInputRef}
                                                        /> */}

                                                        {this.state.fileInputVisible && (
                                                            <input 
                                                                type="file" 
                                                                name='file' 
                                                                required 
                                                                ref={this.fileInputRef} 
                                                                onChange={this.fileChangedHandler} 
                                                            />
                                                        )}
                                                        
                                                        {/* <div className='mt-2  photoAFC'>
                                                            <div className='aa'>
                                                                <div color={this.state.color} fade={this.state.fade} className={this.state.photoLabel ? 'display-block' : 'display-none'}>
                                                                    <h1 className=' mt-5 fontcolorwhite'>2 X 2 </h1>
                                                                    <Label className='  photolabelAFC'>2 X 2 photo</Label>
                                                                    <h1  className=' fontcolorwhite'> 2 X 2</h1>
                                                                </div>
                                                                <div isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.newImageShow ? 'display-block' : 'display-none'}>
                                                                    <img src={this.state.newImage} alt="" />
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                        <div className='mt-2 photoAFC'>
                                                            <div className='aa'>
                                                                <div className={this.state.photoLabel ? 'display-block' : 'display-none'}>
                                                                    <h1 className='mt-5 fontcolorwhite'>2 X 2 </h1>
                                                                    <Label className='photolabelAFC'>2 X 2 photo</Label>
                                                                    <h1 className='fontcolorwhite'> 2 X 2</h1>
                                                                </div>
                                                                <div className={this.state.newImageShow ? 'display-block' : 'display-none'}>
                                                                    <img 
                                                                        src={this.state.newImage} 
                                                                        alt="2 X 2" 
                                                                        style={{height: "200px", width: "200px"}}
                                                                        onError={(e) => { e.target.onerror = null; e.target.src = 'fallback-image-url.jpg'; }} // Fallback image
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </Row>

                                                <Row>
                                                    <Form.Group as={Col} controlId="formGridAddress1">
                                                        <Form.Label style={{fontWeight : "bold"}}>TITLE</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            onChange={this.handleChangeTitle}
                                                            value={this.state.titleValue}
                                                        >
                                                        {this.state.titleDDL.map(item => (
                                                            <option key={item.value} value={item.value}>
                                                            {item.name}
                                                            </option>
                                                        ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>NICK NAME</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="nName"
                                                            value={this.state.nName}
                                                            onChange={this.onChangeNickName} 
                                                            autoComplete="off"
                                                            placeholder="Enter Nick name" 
                                                            onKeyPress={this.handleNickNameDoubleSpaces}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>FIRST NAME</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="fName"
                                                            value={this.state.fName}
                                                            onChange={this.onChangeFirstName} 
                                                            autoComplete="off"
                                                            placeholder="Enter First name" 
                                                            onKeyPress={this.handleFirstNameDoubleSpaces}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>MIDDLE NAME</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="mName"
                                                            value={this.state.mName}
                                                            onChange={this.onChangeMiddleName} 
                                                            autoComplete="off"
                                                            placeholder="Enter Middle name" 
                                                            onKeyPress={this.handleMiddleNameDoubleSpaces}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>LAST NAME</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="lName"
                                                            value={this.state.lName}
                                                            onChange={this.onChangeLastName} 
                                                            autoComplete="off"
                                                            placeholder="Enter Last name" 
                                                            onKeyPress={this.handleLastNameDoubleSpaces}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>SUFFIX NAME</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            onChange={this.onChangeSuffix}
                                                            value={this.state.sName}
                                                        >
                                                        {this.state.suffixDDL.map(item => (
                                                            <option key={item.value} value={item.value}>
                                                            {item.name}
                                                            </option>
                                                        ))}
                                                        </Form.Control>
                                                        {/* <Form.Control 
                                                            type="text"
                                                            name="sName"
                                                            value={this.state.sName}
                                                            onChange={this.onChangeSuffixName} 
                                                            autoComplete="off"
                                                            placeholder="Enter Suffix name" 
                                                        /> */}
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridAddress1">
                                                        <Form.Label style={{fontWeight : "bold", marginLeft : 15}}>DATE OF BIRTH</Form.Label>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <DatePicker
                                                                ref='dateOfBirth'
                                                                selected={this.state.dateOfBirth}
                                                                onChange={this.handleChangeDateOfBirth}
                                                                minDate={this.minDate}
                                                                value={this.props.dateOfBirth}
                                                                dateFormat={"MM/dd/yyyy"}
                                                                placeholderText="Select Date Of Birth "
                                                                className="form-control"
                                                                wrapperClassName="datepicker"
                                                                peekNextMonth
                                                               showMonthDropdown
                                                               showYearDropdown
                                                               dropdownMode="select"
                                                                
                                                            />
                                                        </Form.Group>
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridAddress1">
                                                        <Form.Label style={{fontWeight : "bold"}}>AGE</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="totalAge"
                                                            value={this.state.totalAge}
                                                            onChange={this.onChangeAgeMonth.bind(this)}
                                                            autoComplete="off"
                                                            disabled
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>SSS #</Form.Label>
                                                            <PatternFormat
                                                                name="sss"
                                                                value={this.state.sss}
                                                                onChange={this.onChangeSSS} 
                                                                autoComplete="off"
                                                                format="##-#######-#"
                                                                className="form-control"
                                                                placeholder="Enter SSS Number"
                                                            />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>TIN</Form.Label>
                                                        <PatternFormat
                                                            name="tin"
                                                            value={this.state.tin}
                                                            onChange={this.onChangeTin} 
                                                            autoComplete="off"
                                                            format="###-###-###-###"
                                                            className="form-control"
                                                            placeholder="Enter TIN Number"
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>PHILHEALTH #</Form.Label>
                                                        <PatternFormat
                                                            name="phic"
                                                            value={this.state.phic}
                                                            onChange={this.onChangePhilHealth} 
                                                            autoComplete="off"
                                                            format="##-#########-#"
                                                            className="form-control"
                                                            placeholder="Enter PHILHEALTH Number"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>PAGIBIG #</Form.Label>
                                                        <PatternFormat
                                                            name="pagibig"
                                                            value={this.state.pagibig}
                                                            onChange={this.onChangePagibig} 
                                                            autoComplete="off"
                                                            format="####-####-####"
                                                            className="form-control"
                                                            placeholder="Enter PAGIBIG Number"
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                <Form.Group as={Col} controlId="formGridCity">
                                               {/*  <ButtonToolbar >
                                                    <Button variant="success" style={{width:'100%'}} onClick = {() => this.handleValidate()}>Check Applicant Name / Mandatory Number</Button>
                                                </ButtonToolbar> */}
                                                </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>TYPE</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            onChange={this.handleChangeType}
                                                            value={this.state.typeId}
                                                        >
                                                        {this.state.typeDDL.map(item => (
                                                            <option key={item.value} value={item.value}>
                                                            {item.name}
                                                            </option>
                                                        ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>REGION</Form.Label>
                                                            <Typeahead
                                                             labelKey='name'
                                                             name="regionId"
                                                             id="regionId"
                                                             onChange={this.handleChangeRegion}
                                                             options={this.state.regionDDL}
                                                             defaultInputValue={this.state.region}
                                                             defaultSelected={[this.state.region]}
                                                             //selected={[this.state.region]}
                                                             placeholder={this.state.region}
                                                            />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>PROVINCE</Form.Label>
                                                            <Typeahead
                                                                 //ref='provinceref'
                                                                 labelKey='name'
                                                                 id="basic-example"
                                                                 onChange={this.handleChangeProvince}
                                                                 options={this.state.provinceDDL}
                                                                 placeholder={this.state.provinceName}
                                                                 defaultSelected={[this.state.provinceName]}
                                                                 defaultInputValue={this.state.provinceName}

                                                            />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>CITY/MUNICIPALITY</Form.Label>
                                                            <Typeahead    
                                                                labelKey='name'
                                                                id="basic-examplex"
                                                                onChange={this.handleChangeCity}
                                                                options={this.state.cityDDL}
                                                                placeholder={this.state.cityName}
                                                                defaultSelected={[this.state.cityName]}
                                                                //selected={[this.state.cityName]}
                                                                defaultInputValue={this.state.cityName}

                                                                
                                                            />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>HOUSE NUMBER</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="houseNumber"
                                                            value={this.state.houseNumber}
                                                            placeholder="Enter House Number"
                                                            onChange={this.onChangeHouseNumber} 
                                                            autoComplete="off"  
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>STREET</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="street"
                                                            value={this.state.street}
                                                            placeholder="Enter Street"
                                                            onChange={this.onChangeStreet} 
                                                            autoComplete="off"  
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>BARANGAY</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="barangay"
                                                            value={this.state.barangay}
                                                            placeholder="Enter barangay"
                                                            onChange={this.onChangeBarangay} 
                                                            autoComplete="off"  
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>POSTAL CODE</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="postalCode"
                                                            value={this.state.postalCode}
                                                            placeholder="Enter Postal Code"
                                                            onChange={this.onChangePostalCode} 
                                                            autoComplete="off"  
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>HOME PHONE NUMBER</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="hpNumber"
                                                            value={this.state.hpNumber}
                                                            placeholder="Enter Home Phone Number"
                                                            onChange={this.onChangeHPNumber} 
                                                            autoComplete="off"        
                                                            maxLength="8"  
                                                        />
                                                        {/* <NumberFormat
                                                            name="hpNumber"
                                                            value={this.state.hpNumber}
                                                            onChange={this.onChangeHPNumber} 
                                                            autoComplete="off"
                                                            format="####-####"
                                                            className="form-control"
                                                            placeholder="Enter Home Phone Number"
                                                        /> */}
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>OFFICE PHONE NUMBER</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="opNumber"
                                                            value={this.state.opNumber}
                                                            placeholder="Enter Office Phone Number"
                                                            onChange={this.onChangeOPNumber} 
                                                            autoComplete="off"        
                                                            maxLength="8"   
                                                        />
                                                        {/* <NumberFormat
                                                            name="opNumber"
                                                            value={this.state.opNumber}
                                                            onChange={this.onChangeOPNumber} 
                                                            autoComplete="off"
                                                            format="####-####"
                                                            className="form-control"
                                                            placeholder="Enter Office Phone Number"
                                                        /> */}
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>MOBILE NUMBER</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="mobileNumber"
                                                            value={this.state.mobileNumber}
                                                            placeholder="Enter Mobile Number"
                                                            onChange={this.onChangeMobileNumber} 
                                                            autoComplete="off"          
                                                            maxLength="11"
                                                            //onKeyPress={this.IsNumeric.bind(this)}
                                                            onBlur={this.ValidateMobileNumber}
                                                        />
                                                        {/* <NumberFormat
                                                            name="mobileNumber"
                                                            value={this.state.mobileNumber}
                                                            onChange={this.onChangeMobileNumber} 
                                                            autoComplete="off"
                                                            format="####-####-###"
                                                            className="form-control"
                                                            placeholder="Enter Mobile Number"
                                                        /> */}
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formBasicEmail">
                                                        <Form.Label style={{fontWeight : "bold"}}>EMAIL ADDRESS</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="emailAddress"
                                                            value={this.state.emailAddress}
                                                            placeholder="Enter Email Address"
                                                            onChange={this.onChangeEmailAddress} 
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>FACEBOOK</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="facebook"
                                                            value={this.state.facebook}
                                                            placeholder="Enter Facebook"
                                                            onChange={this.onChangeFacebook} 
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>TWITTER</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="twitter"
                                                            value={this.state.twitter}
                                                            placeholder="Enter Twitter"
                                                            onChange={this.onChangeTwitter} 
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridAddress1">
                                                        <Form.Label style={{fontWeight : "bold"}}>CITIZENSHIP</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            onChange={this.handleChangeCitizenship}
                                                            value={this.state.nationalityId}
                                                        >
                                                        {this.state.nationalityDDL.map(item => (
                                                            <option key={item.value} value={item.value}>
                                                            {item.name}
                                                            </option>
                                                        ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridAddress1">
                                                        <Form.Label style={{fontWeight : "bold"}}>RELIGION</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            onChange={this.handleChangeReligion}
                                                            value={this.state.religionId}
                                                        >
                                                        {this.state.religionDDL.map(item => (
                                                            <option key={item.value} value={item.value}>
                                                            {item.name}
                                                            </option>
                                                        ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridAddress1">
                                                        <Form.Label style={{fontWeight : "bold"}}>GENDER</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            onChange={this.handleChangeGender}
                                                            value={this.state.genderValue}
                                                        >
                                                        {this.state.genderDDL.map(item => (
                                                            <option key={item.value} value={item.value}>
                                                            {item.name}
                                                            </option>
                                                        ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridAddress1">
                                                        <Form.Label style={{fontWeight : "bold"}}>CIVIL STATUS</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            onChange={this.handleChangeCivilStatus}
                                                            value={this.state.civilStatusValue}
                                                        >
                                                        {this.state.civilStatusDDL.map(item => (
                                                            <option key={item.value} value={item.value}>
                                                            {item.name}
                                                            </option>
                                                        ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Row> 
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>LIVING ARRANGEMENT</Form.Label>
                                                        <Typeahead
                                                            labelKey='name'
                                                            id='arrangementId'
                                                            name='arrangementId'
                                                            options={this.state.arrangementDDL}
                                                            onChange={this.handleChangedArrangement}
                                                            placeholder={this.state.arrangement}

                                                            defaultSelected={[this.state.arrangement]}
                                                            defaultInputValue={this.state.arrangement}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>BLOOD TYPE</Form.Label>
                                                        <Typeahead
                                                             labelKey='name'
                                                             id='bloodtypeId'
                                                             name='bloodtypeId'
                                                             options={this.state.bloodtypeDDL}
                                                             onChange={this.handleChangedBloodType}
                                                             placeholder={this.state.bloodtype}
                                                             

                                                            defaultSelected={[this.state.bloodtype]}
                                                            defaultInputValue={this.state.bloodtype}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>PLACE OF BIRTH</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="placeOfBirth"
                                                            value={this.state.placeOfBirth}
                                                            placeholder="Enter Place Of Birth"
                                                            onChange={this.onChangePlaceOfBirth} 
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>HEIGHT</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="height"
                                                            value={this.state.height}
                                                            placeholder="Enter Height"
                                                            onChange={this.onChangeHeight} 
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>WEIGHT</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="weight"
                                                            value={this.state.weight}
                                                            placeholder="Enter Weight"
                                                            onChange={this.onChangeWeight} 
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>SPECIAL SKILLS</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="sSkills"
                                                            value={this.state.sSkills}
                                                            placeholder="Enter Special Skills"
                                                            onChange={this.onChangeSkills} 
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>LANGUAGE SPOKEN</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="lSpoken"
                                                            value={this.state.lSpoken}
                                                            placeholder="Enter Language Spoken"
                                                            onChange={this.onChangeLSpoken} 
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>EMERGENCY CONTACT NAME</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="ecName"
                                                            value={this.state.ecName}
                                                            placeholder="Enter Emergency Contact Name"
                                                            onChange={this.onChangeECName} 
                                                            autoComplete="off"
                                                            //maxLength="11"
                                                            //onKeyPress={this.IsNumeric.bind(this)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>RELATIONSHIP</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="relationship"
                                                            value={this.state.relationship}
                                                            placeholder="Enter Relationship"
                                                            onChange={this.onChangeRelationship} 
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>EMERGENCY CONTACT NUMBER</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="ecNumber"
                                                            value={this.state.ecNumber}
                                                            placeholder="Enter Emergency Contact Number"
                                                            onChange={this.onChangeECNumber} 
                                                            autoComplete="off"         
                                                            maxLength="11" 
                                                            onBlur={this.ValidateMobileNumber}
                                                        />
                                                        {/* <NumberFormat
                                                            name="ecNumber"
                                                            value={this.state.ecNumber}
                                                            onChange={this.onChangeECNumber} 
                                                            autoComplete="off"
                                                            format="####-####-###"
                                                            className="form-control"
                                                            placeholder="Enter Emergency Contact Number"
                                                        /> */}
                                                    </Form.Group>
                                                </Row>
                                                {/* ADDED BY NEL */}
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridAddress1">
                                                        <Form.Label style={{fontWeight : "bold"}}>CURRENT RESUME</Form.Label> &nbsp;&nbsp;&nbsp;
                                                        {this.state.matchedDocumentName && (
                                                            <span style={{ fontWeight: 'normal', color: 'black' }}>
                                                                {this.state.matchedDocumentName}
                                                            </span>
                                                        )}

                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}></Form.Label> &nbsp;&nbsp;&nbsp;
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridAddress1">
                                                        <Form.Label style={{fontWeight : "bold"}}>UPLOAD NEW RESUME</Form.Label> &nbsp;&nbsp;&nbsp;
                                                        <input 
                                                            type="file" 
                                                            name='uploadResume' 
                                                            onChange={this.fileUploadChangedHandler} 
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}></Form.Label> &nbsp;&nbsp;&nbsp;
                                                    </Form.Group>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Tab>
                                    
                                    <Tab eventKey="education" title="II. EDUCATION">
                                        <Card className="card-tab-no-border">
                                            <Card.Body className="appFormBackground1">
                                                
                                                    
                                                {/* <ButtonToolbar className="mt-3">
                                                    <Button variant="success" onClick = { this.handleAddEducation }>Add</Button>
                                                    <Button className="noser-button-mr1" disabled={this.state.disableRemoveEducation} className="noser-button" variant="danger" onClick = { this.handleRemoveEducation }>REMOVE</Button>
                                                </ButtonToolbar> */}
                                                <div className="mt-1">  
                                                    <div>
                                                        <Card.Header>EDUCATION LIST</Card.Header>
                                                        <BootstrapTable
                                                            keyField = "id"
                                                            data = { this.state.educationGrid }
                                                            columns = { educationColumn }
                                                            //pagination={ paginationFactory({sizePerPageRenderer}) }
                                                            noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                                            rowClasses="noser-table-row-class no-checkbox"
                                                            striped
                                                            hover
                                                            condensed
                                                            cellEdit = { cellEditFactory({
                                                                mode: 'dbclick',
                                                                blurToSave: true,
                                                                afterSaveCell: (oldValue, newValue, row, column) => {
                                                                    this.EducationGridDataModified(oldValue, newValue, row.id, column.dataField)
                                                                    }
                                                                })
                                                            }
                                                            //selectRow = { educationSelectRow }
                                    
                                                        />
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                            
                                    </Tab>

                                    <Tab eventKey="employment" title=" III. EMPLOYMENT RECORD (START WITH LATEST EMPLOYER)">
                                        <Card className="card-tab-no-border">
                                            <Card.Body className="appFormBackground1">
                                                <Row className="mt-3">
                                                    <Form.Group as={Col} controlId="formBasicCheckbox">
                                                        <Form.Check
                                                            inline 
                                                            type="checkbox" 
                                                            label="FRESH GRADUATE ?" 
                                                            name="isFreshGraduate"
                                                            checked={this.state.checkIsFreshGraduate}
                                                            onChange={this.onChangesFreshGraduate}
                                                            style={{fontWeight : "bold", marginTop : "3px"}}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>COMPANY NAME</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="erCompanyName"
                                                            value={this.state.erCompanyName}
                                                            onChange={this.onChangeERCompanyName} 
                                                            autoComplete="off"
                                                            placeholder="Enter Company Name" 
                                                            disabled={this.state.isEmploymentDisabled}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>COMPANY ADDRESS</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="erCompanyAddress"
                                                            value={this.state.erCompanyAddress}
                                                            onChange={this.onChangeERCompanyAddress} 
                                                            autoComplete="off"
                                                            placeholder="Enter Company Address" 
                                                            disabled={this.state.isEmploymentDisabled}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>POSITION</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="erEmptyField"
                                                            value={this.state.erPosition}
                                                            onChange={this.onChangeERPosition} 
                                                            autoComplete="off"
                                                            placeholder="Enter Position" 
                                                            disabled={this.state.isEmploymentDisabled}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group className='mt-2' as={Col} controlId="formGridCity">
                                                        <Form.Label  style={{fontWeight : "bold"}}>PERIOD COVERED</Form.Label>&nbsp;&nbsp;
                                                      
                                                        <DatePicker
                                                                ref='fromStart'
                                                                selected={this.state.fromStart}
                                                                onChange={this.handleChangeFromStart}
                                                                minDate={this.minDate}
                                                                value={this.props.fromStart}
                                                                dateFormat={"MM/dd/yyyy"}
                                                                placeholderText="Select Date from "
                                                                className="form-control"
                                                                wrapperClassName="datepicker"
                                                                //showMonthYearPicker
                                                                //showMonthDropdown
                                                                //showYearDropdown
                                                                //dropdownMode= "scroll"
                                                                
                                                        />&nbsp; &nbsp;
                                                        <DatePicker
                                                                ref='toEnd'
                                                                selected={this.state.toEnd}
                                                                onChange={this.handleChangeToEnd}
                                                                minDate={this.minDate}
                                                                value={this.props.toEnd}
                                                                dateFormat={"MM/dd/yyyy"}
                                                                placeholderText="Select Date to "
                                                                className="form-control"
                                                                wrapperClassName="datepicker"
                                                                //showMonthYearPicker
                                                                //showMonthDropdown
                                                                //showYearDropdown
                                                                //dropdownMode= "scroll"
                                                                
                                                        />
                                                        {/* <Form.Control 
                                                            type="text"
                                                            name="erPeriodCover"
                                                            value={this.state.erPeriodCover}
                                                            onChange={this.onChangeERCPeriodCover} 
                                                            autoComplete="off"
                                                            placeholder="Enter Period Cover" 
                                                            disabled={this.state.isEmploymentDisabled}
                                                        /> */}
                                                        
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col}  controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>SALARY</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="erSalary"
                                                            value={this.state.erSalary}
                                                            onChange={this.onChangeERSalary} 
                                                            autoComplete="off"
                                                            placeholder="Enter Salary" 
                                                            disabled={this.state.isEmploymentDisabled}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>Reason for leaving</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="erRFLeaving"
                                                            value={this.state.erRFLeaving}
                                                            onChange={this.onChangeERRFLeaving} 
                                                            autoComplete="off"
                                                            placeholder="Enter Reason For Leaving" 
                                                            //disabled={this.state.isEmploymentDisabled}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                {/* <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>PasdasdRED</Form.Label>
                                                        <DatePicker
                                                                ref='fromStart'
                                                                selected={this.state.fromStart}
                                                                onChange={this.handleChangeFromStart}
                                                                minDate={this.minDate}
                                                                value={this.props.fromStart}
                                                                dateFormat={"MM/dd/yyyy"}
                                                                placeholderText="Select Date Of Birth "
                                                                className="form-control"
                                                                wrapperClassName="datepicker"
                                                                //showMonthDropdown
                                                                //showYearDropdown
                                                                //dropdownMode= "scroll"
                                                                
                                                            />
                                                    </Form.Group> */}
                                                <ButtonToolbar className="mt-3">
                                                    <Button size="sm"  variant="success" onClick = { this.handleAddEmploymentRecord }>Add</Button>&nbsp; &nbsp;
                                                    <Button size="sm" disabled={this.state.disableRemoveEmploymentRecord} className="noser-button" variant="danger" onClick = { this.handleRemoveEmploymentRecord }>REMOVE</Button>
                                                </ButtonToolbar>
                                                <div className="mt-1">  
                                                    <div>
                                                        <Card.Header>EMPLOYMENT RECORDS LIST</Card.Header>
                                                        <BootstrapTable
                                                            keyField = "id"
                                                            data = { this.state.employmentRecordGrid }
                                                            columns = { employmentRecordColumn }
                                                            //pagination={ paginationFactory({sizePerPageRenderer}) }
                                                            noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                                            rowClasses="noser-table-row-class"
                                                            striped
                                                            hover
                                                            condensed
                                                            cellEdit = { cellEditFactory({
                                                                mode: 'dbclick',
                                                                blurToSave: true,
                                                                afterSaveCell: (oldValue, newValue, row, column) => {
                                                                    this.EmploymentGridDataModified(oldValue, newValue, row.id, column.dataField)
                                                                    }
                                                                })
                                                            }
                                                            selectRow = { employmentRecordSelectRow }
                                    
                                                        />
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                            
                                    </Tab>


                                    <Tab eventKey="familybackground" title="IV. FAMILY BACKGROUND">
                                        <Card className="card-tab-no-border">
                                            <Card.Body className="appFormBackground1">
                                                
                                                <ButtonToolbar className="mt-3">
                                                    <Button size="sm" variant="success" onClick = { this.handleAddFamilybackground }>Add</Button>&nbsp; &nbsp;
                                                    <Button size="sm" disabled={this.state.disableBackground} className="noser-button" variant="danger" onClick = { this.handleRemoveBackground }>REMOVE</Button>
                                                </ButtonToolbar>
                                                <div className="mt-1">  
                                                    <div>
                                                        <Card.Header>Family Background List</Card.Header>
                                                        <BootstrapTable
                                                            keyField = "id"
                                                            data = { this.state.familyBackgroundGrid }
                                                            columns = { familyBackgroundColumn }
                                                            //pagination={ paginationFactory({sizePerPageRenderer}) }
                                                            noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                                            rowClasses="noser-table-row-class"
                                                            striped
                                                            hover
                                                            condensed
                                                            cellEdit = { cellEditFactory({
                                                                mode: 'dbclick',
                                                                blurToSave: true,
                                                                afterSaveCell: (oldValue, newValue, row, column) => {
                                                                    this.FamilyBackgroundGridDataModified(oldValue, newValue, row.id, column.dataField)
                                                                    }
                                                                })
                                                            }
                                                            selectRow = { familyBackgroundSelectRow }
                                    
                                                        />
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>   
                                    </Tab>
                                                            
                                    <Tab eventKey="others" title="V. OTHERS">
                                        <Card className="card-tab-no-border">
                                            <Card.Body className="appFormBackground1">
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>HOW DID YOU LEARN ABOUT THIS JOB OPENING ?</Form.Label>
                                                        <Form.Control
                                                                as="select"
                                                                onChange={this.handleChangeJobOpening}
                                                                value={this.state.jobSourceId}
                                                            >
                                                            {this.state.jobOpeningDDL.map(item => (
                                                                <option key={item.value}  value={item.value} >
                                                                {item.name}
                                                                </option>
                                                            ))}
                                                        </Form.Control>
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>REFERRED BY</Form.Label>
                                                        <div>
                                                            <div /* isOpen={this.state.isshow} */ color={this.state.color} fade={this.state.fade} className={this.state.referealOthersTA ? 'display-block' : 'display-none'}>
                                                                <Typeahead
                                                                    ref="refReferredBy"
                                                                    labelKey='employeeName'
                                                                    id="basic-example"
                                                                    onChange={this.handleChangeReferral}
                                                                    options={this.state.referralDDL}
                                                                    placeholder="Select Referral"
                                                                    disabled={this.state.disablereferral}
                                                                    onInputChange={this.handledOnSearch}
                                                                />
                                                            </div>
                                                            <div color={this.state.color} fade={this.state.fade} className={this.state.referealOthersTXT ? 'display-block' : 'display-none'}>
                                                                <Form.Control 
                                                                    type="text"
                                                                    name="oReferredBy"
                                                                    value={this.state.oReferredBy}
                                                                    onChange={this.onChangeOthersRefferedBy} 
                                                                    autoComplete="off"
                                                                    placeholder="Enter Reffered By" 
                                                                    disabled={this.state.disablereferral}
                                                                /> 
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </Row>
                                                <hr/>
                                                <div style={{height : 5}}></div>
                                                <Row className="mt-3">
                                                    <Form.Group as={Col} sm="5" controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>DO YOU HAVE RELATIVES OR FRIENDS PRESENTLY CONNECTED WITH THIS COOPERATIVE ?</Form.Label>
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formBasicCheckbox">
                                                        <Form.Check
                                                            inline 
                                                            type="checkbox" 
                                                            label="YES" 
                                                            name="checkORelativeYes"
                                                            checked={this.state.checkORelativeYes}
                                                            onChange={this.onChangeORelativeYes}
                                                            style={{fontWeight : "bold", marginTop : "3px"}}
                                                        />
                                                        <Form.Check 
                                                            inline
                                                            type="checkbox" 
                                                            label="NO" 
                                                            name="checkORelativeNo"
                                                            checked={this.state.checkORelativeNo}
                                                            onChange={this.onChangeORelativeNo}
                                                            style={{fontWeight : "bold", marginTop : "3px", marginLeft : 12}}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>NAME</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="oRelativeName"
                                                            value={this.state.oRelativeName}
                                                            onChange={this.onChangeORelativeName} 
                                                            autoComplete="off"
                                                            placeholder="Enter Name" 
                                                            disabled={ this.state.disabledRelative}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>CONTACT NUMBER</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="oCNumber"
                                                            value={this.state.oCNumber}
                                                            placeholder="Enter Contact Number"
                                                            onChange={this.onChangeOCNumber} 
                                                            autoComplete="off"  
                                                            disabled={ this.state.disabledRelative}            
                                                            maxLength="11" 
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>RELATIONSHIP</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="oRelationship"
                                                            value={this.state.oRelationship}
                                                            onChange={this.onChangeORelationship} 
                                                            autoComplete="off"
                                                            placeholder="Enter Relationship"
                                                            disabled={ this.state.disabledRelative}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>JOB TITLE</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="oJobTitle"
                                                            value={this.state.oJobTitle}
                                                            onChange={this.onChangeOJobTitle} 
                                                            autoComplete="off"
                                                            placeholder="Enter Job Title"
                                                            disabled={ this.state.disabledRelative}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <hr/>
                                                <div style={{height : 5}}></div>
                                                <Row className="mt-3">
                                                    <Form.Group as={Col} sm="3" controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>HAVE YOU BEEN CONVICTED OF A CRIME ?</Form.Label>
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formBasicCheckbox">
                                                        <Form.Check
                                                            inline 
                                                            type="checkbox" 
                                                            label="YES" 
                                                            name="checkConvictedYes"
                                                            checked={this.state.checkConvictedYes}
                                                            onChange={this.onChangeOthersConvictedYes}
                                                            style={{fontWeight : "bold", marginTop : "3px"}}
                                                        />
                                                        <Form.Check 
                                                            inline
                                                            type="checkbox" 
                                                            label="NO" 
                                                            name="checkConvictedNo"
                                                            checked={this.state.checkConvictedNo}
                                                            onChange={this.onChangeOthersConvictedNo}
                                                            style={{fontWeight : "bold", marginTop : "3px", marginLeft : 12}}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>IF YES, PLEASE GIVE DETAILS</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="oCrime"
                                                            value={this.state.oCrime}
                                                            onChange={this.onChangeOCrime} 
                                                            autoComplete="off"
                                                            placeholder="Enter If Yes, Please Give Details"
                                                            disabled={ this.state.disabledConvicted}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <hr/>
                                                <div style={{height : 5}}></div>
                                                <Row className="mt-3">
                                                    <Form.Group as={Col} sm="3" controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>HAVE YOU BEEN A MEMBER OF A LABOR UNION ?</Form.Label>
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formBasicCheckbox">
                                                        <Form.Check
                                                            inline 
                                                            type="checkbox" 
                                                            label="YES" 
                                                            name="checkLaborUnionYes"
                                                            checked={this.state.checkLaborUnionYes}
                                                            onChange={this.onChangeOthersLaborUnionYes}
                                                            style={{fontWeight : "bold", marginTop : "3px"}}
                                                        />
                                                        <Form.Check 
                                                            inline
                                                            type="checkbox" 
                                                            label="NO" 
                                                            name="checkLaborUnionNo"
                                                            checked={this.state.checkLaborUnionNo}
                                                            onChange={this.onChangeOthersLaborUnionNo}
                                                            style={{fontWeight : "bold", marginTop : "3px", marginLeft : 12}}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mt-2">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>IF YES, GIVE DETAILS</Form.Label>
                                                        <Form.Control 
                                                            type="text"
                                                            name="luDetails"
                                                            value={this.state.luDetails}
                                                            onChange={this.onChangeLUDetails} 
                                                            autoComplete="off"
                                                            placeholder="Enter If Yes, Give Details"
                                                            disabled={ this.state.disabledLaborUnion}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <hr/>
                                                <div style={{height : 5}}></div>
                                                <Row className="mt-3">
                                                    <Form.Group as={Col} sm="6" controlId="formGridCity">
                                                        <Form.Label style={{fontWeight : "bold"}}>HAVE YOU SUFFERED OR BEEN DIAGNOSED TO HAVE ANY OF THE FF. CHRONIC DISEASE(S) OR LIKES ?</Form.Label>
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formBasicCheckbox">
                                                        <Form.Check
                                                            inline 
                                                            type="checkbox" 
                                                            label="YES" 
                                                            name="checkChronicDiseaseYes"
                                                            checked={this.state.checkChronicDiseaseYes}
                                                            onChange={this.onChangeOthersChronicDiseaseYes}
                                                            style={{fontWeight : "bold", marginTop : "3px"}}
                                                        />
                                                        <Form.Check 
                                                            inline
                                                            type="checkbox" 
                                                            label="NO" 
                                                            name="checkChronicDiseaseNo"
                                                            checked={this.state.checkChronicDiseaseNo}
                                                            onChange={this.onChangeOthersChronicDiseaseNo}
                                                            style={{fontWeight : "bold", marginTop : "3px", marginLeft : 12}}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row >
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Control
                                                            as="select"
                                                            onChange={this.handleChangeDisease}
                                                            value={this.state.diagnoseDeseaseId}
                                                            disabled = { this.state.disabledDisease} 
                                                        >
                                                        {this.state.diseaseDDL.map(item => (
                                                            <option key={item.value} value={item.value}>
                                                            {item.name}
                                                            </option>
                                                        ))}
                                                        
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                            
                                    </Tab>
                                    
                                    <Tab eventKey="reference" title="VI. REFERENCES (NOT RELATED TO YOUR FAMILY)">
                                        <Card className="card-tab-no-border">
                                            <Card.Body className="appFormBackground1">
                                                <ButtonToolbar className="mt-3">
                                                    <Button size="sm" variant="success" onClick = { this.handleAddReference }>Add</Button>&nbsp; &nbsp;
                                                    <Button size="sm" disabled={this.state.handleRemoveReference} className="noser-button" variant="danger" onClick = { this.handleRemoveBackground }>REMOVE</Button>
                                                </ButtonToolbar>
                                            <Card.Header>Reference List</Card.Header>
                                                        <BootstrapTable
                                                            keyField = "id"
                                                            data = { this.state.referenceGrid }
                                                            columns = { referenceColumn }
                                                            //pagination={ paginationFactory({sizePerPageRenderer}) }
                                                            noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                                            rowClasses="noser-table-row-class"
                                                            striped
                                                            hover
                                                            condensed
                                                            cellEdit = { cellEditFactory({
                                                                mode: 'dbclick',
                                                                blurToSave: true,
                                                                afterSaveCell: (oldValue, newValue, row, column) => {
                                                                    this.ReferenceGridDataModified(oldValue, newValue, row.id, column.dataField)
                                                                    }
                                                                })
                                                            }
                                                            selectRow = { referenceSelectRow }
                                    
                                                        />
                                            </Card.Body>
                                        </Card>
                                    </Tab>
                                </Tabs>

                               
                                <hr/>
                                <Card >
                                    <Card.Body >
                                        <div style={{fontSize : "12px"}}>
                                            <Row>
                                                <Form.Group as={Col} sm="4" controlId="formBasicCheckbox">
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formBasicCheckbox">
                                                    {/* <Form.Check
                                                        inline 
                                                        type="checkbox" 
                                                        label="I HAVE READ AND AGREE TO THE TERMS AND CONDITIONS AND PRIVACY POLICY." 
                                                        name="checkDisclaimer"
                                                        checked={this.state.checkDisclaimer}
                                                        onChange={this.onChangeDisclaimer}
                                                        style={{fontWeight : "bold", marginTop : "3px",border: "2px"}}
                                                        className='customcheck'
                                                    // isValid
                                                    /> */}
                                                    <label class="customcheck" style={{fontWeight : "bold"}}>
                                                    <input
                                                        type="checkbox" 
                                                        name="checkDisclaimer"
                                                        checked={this.state.checkDisclaimer}
                                                        onChange={this.onChangeDisclaimer}
                                                    />&nbsp;
                                                        I HAVE READ AND AGREE TO THE TERMS AND CONDITIONS AND PRIVACY POLICY.
                                                    </label>
                                                </Form.Group>
                                            </Row>
                                            <Row>
                                                <Form.Group as={Col} controlId="formBasicCheckbox">
                                                <label style={{color : "#000"}}>
                                                    I understand and agree to the Terms and Conditions and Data Privacy Policy of JobSpace. I gave my consents to the collection, use, and storage of
                                                    the following personal information: such as Name, Date of Birth, Phone/Mobile Number, E-mail Address, Photo, Educational Background, Work 
                                                    Experiences including the names and contact nos. of my references, and all the other details stated in my JobSpace account. 
                                                    As such, I voluntarily and authorize JobSpace to share and disclose my profile to their clients, employers and recruitment partners. Who are looking
                                                    for candidates, to facilitate job matching on which sharing of information is required. 
                                                </label>
                                                </Form.Group>
                                            </Row>
                                        
                                        </div>
                                    </Card.Body>
                                </Card>
                                <Row>
                                    <Col sm={9}></Col>
                                    <Col sm={1}></Col>
                                   
                                    &nbsp;
                                    <Col >
                                        <ButtonToolbar className="mt-3 ml-auto" style={{marginLeft: "30%"}}>
                                            {/* <Button disabled={this.state.disablebutton}  className="ml-auto noser-button-mr1" variant="success" onClick = {() => this.handleClickStatus('1')}>SAVE AS DRAFT</Button> */}
                                            <Button 
                                                disabled={this.state.disablebutton} 
                                                className="ml-auto" 
                                                size="sm"   
                                                variant="success" 
                                                onClick = {() => this.handleClickStatus('2')}
                                            >
                                                  {this.state.loading ? <Spinner size="lg" color="light" /> : "SAVE"}
                                            </Button>&nbsp;&nbsp;
                                            <Button  href="/ApplicationFormView" className="" size="sm" variant="dark">BACK</Button>
                                        </ButtonToolbar>
                                    </Col>
                                </Row>
                                
                            </Form>
                        </Card.Body>
                    </Card>
                    <div style={{height : 15}}></div>
                </Container>
                {/* <NoserLoading show={this.state.isloading} /> */}
                <Modal backdrop="static" isOpen={showModal} toggle={() => this.setState({ showModal: false })}>
                    <div className="modal-header">
                        {/* <h5 className="modal-title">Success</h5> */}
                       {/*  <button type="button" className="close" onClick={() => this.setState({ showModal: false })}>
                            <span>&times;</span>
                        </button> */}
                    </div>
                    <div className="modal-body">
                        <p>Successfully saved!</p>
                    </div>
                    <div className="modal-footer">
                        <Button color="primary" onClick={this.lipatViewBTNmodal}>
                            OK
                        </Button>
                    </div>
                </Modal>
        </div>
        )
    }

}

export  default ApplicationFormEdit;